{
  "\"chart.tooltip.substat.phase\"": "Phase {number, select, 0 {1} 1 {2} 2 {3} other {{number}}}",
  "\"chart.tooltip.substat.pv_string\"": "{inverterName}, String {stringNumber}",
  "TEST": "XXX",
  "animation.battery": "Batterie",
  "animation.boiler": "Boiler",
  "animation.consumption": "Haus",
  "animation.electrical_grid": "Netz",
  "animation.hp": "Wärmepumpe",
  "animation.photovoltaics": "Photovoltaik",
  "animation.wallbox": "Wallbox",
  "animation.wind": "Wind",
  "app_messages.battery_max_soc": "Batterie wird auf die eingestellte maximale SOC {maxSoc, number, ::.##}% geladen",
  "app_messages.battery_min_soc": "Batterie wird auf die eingestellte minimale SOC {minSoc, number, ::.##}% entladen",
  "app_messages.body.battery_max_soc": "Der aktuelle Batterieladestand beträgt {currentSoc, number, ::.##}%.",
  "app_messages.body.battery_min_soc": "Der aktuelle Batterieladestand beträgt {currentSoc, number, ::.##}%.",
  "app_messages.body.heat_pump_limit_exceeded": "Das Limit für den Wärmepumpenverbrauch wurde überschritten. Das eingestellte Limit beträgt {value, number, ::.##} kW.",
  "app_messages.body.heat_water_limit_exceeded": "Das Limit für den Warmwasserverbrauch wurde überschritten. Das eingestellte Limit beträgt {value, number, ::.##} kW.",
  "app_messages.body.heat_water_max_temperature": "Heute hat der Boiler bereits die maximale Temperatur {maxTemperature, number, ::.##}°C erreicht.",
  "app_messages.body.home_limit_exceeded": "Das Limit für den Hausverbrauch wurde überschritten. Das eingestellte Limit beträgt {value, number, ::.##} kW.",
  "app_messages.body.inverter_production_mwh": "Ihre Photovoltaikanlage hat in diesem Jahr bereits {inverterProductionValue, number, ::.##} MWh erzeugt.",
  "app_messages.body.spot_daily_prediction": "Tagesprognose: {pvPrediction, select, true {Photovoltaik-Erzeugung: {pvPredictionValue, number, ::.##} kWh. } other {} } {homePrediction, select, true {Hausverbrauch: {homePredictionValue, number, ::.##} kWh. } other {} } {batteryPrediction, select, true {Batteriespeicher: {batteryPredictionValue, number, ::.##} kWh. } other {} } {hwPrediction, select, true {Boilerspeicher: {hwPredictionValue, number, ::.##} kWh. } other {} } {hpPrediction, select, true {Wärmepumpenverbrauch: {hpPredictionValue, number, ::.##} kWh. } other {} } {salePrediction, select, true {Verbleibende Energie zum Verkauf: {salePredictionValue, number, ::.##} kWh. } other {} }",
  "app_messages.body.spot_daily_summary": "Heute am Spot: {nothingToReport, select, true {Nichts ist geplant.} other { {energyForSale, select, true {Der Plan sieht einen Verkauf am Morgen vor. } other {} } {negativeIntervals, select, false {} other {Negativer Preis ({negativeIntervals}), der den Überschuss reduziert. } } {chargingIntervals, select, false {} other {Plan zum Laden der Batterie ({chargingIntervals}). } } {dischargingIntervals, select, false {} other {Plan zum Entladen der Batterie ({dischargingIntervals}). } } } }",
  "app_messages.body.spot_negative_price_start": "Der aktuelle Spotpreis ist nach Abzug der Provision negativ. Die in Infigy eingestellte Provision beträgt {spotOffsetPrice, number, ::.##} CZK. Der aktuelle Spotpreis beträgt {spotNegativePrice, number, ::.##} CZK.",
  "app_messages.body.spot_negative_price_stop": "Der aktuelle Spotpreis ist nicht mehr negativ und beträgt {spotNegativePrice, number, ::.##} CZK. Die Provision ist in Infigy auf {spotOffsetPrice, number, ::.##} CZK eingestellt",
  "app_messages.body.wallbox_limit_exceeded": "Das Ladelimit des Elektrofahrzeugs wurde überschritten. Das eingestellte Limit beträgt {value, number, ::.##} kW.",
  "app_messages.body.wallbox_stop_charging": "In diesem Zyklus wurden {wallboxConsumptionCycleValue, number, ::.##} kWh Energie hinzugefügt.",
  "app_messages.button": "Alle Nachrichten löschen",
  "app_messages.cancel": "Abbrechen",
  "app_messages.confirm": "Alle Nachrichten löschen",
  "app_messages.confirm.title": "Möchten Sie wirklich alle Nachrichten löschen?",
  "app_messages.detail_dialog.close": "Lesen",
  "app_messages.heat_pump_limit_exceeded": "Das Limit für den Wärmepumpenverbrauch wurde überschritten",
  "app_messages.heat_water_limit_exceeded": "Das Limit für den Warmwasserverbrauch wurde überschritten",
  "app_messages.heat_water_max_temperature": "Die maximale Wassertemperatur wurde erreicht",
  "app_messages.home_limit_exceeded": "Das Limit für den Hausverbrauch wurde überschritten",
  "app_messages.inverter_connected": "Die Kommunikation mit dem Wechselrichter wurde hergestellt",
  "app_messages.inverter_disconnected": "Die Kommunikation mit dem Wechselrichter wurde unterbrochen",
  "app_messages.inverter_production_mwh": "PV-Erzeugungsmeilenstein",
  "app_messages.load_more": "Mehr laden",
  "app_messages.no_messages": "Es sind noch keine Benachrichtigungen vorhanden",
  "app_messages.spot_battery_discharge": "Der spotbasierte Entladeplan ist {spotDischargePlan}",
  "app_messages.spot_daily_prediction": "Tagesprognose",
  "app_messages.spot_daily_summary": "Tageszusammenfassung des Spotplans",
  "app_messages.spot_negative_price_start": "Der Spotpreis ist negativ",
  "app_messages.spot_negative_price_stop": "Der Spotpreis ist nicht mehr negativ",
  "app_messages.spot_start_charging_battery": "Das Laden der Batterie gemäß Spotpreis wurde gestartet",
  "app_messages.spot_start_discharging_battery": "Das Entladen der Batterie ins Netz gemäß Spotpreis wurde gestartet",
  "app_messages.spot_stop_charging_battery": "Das Laden der Batterie gemäß Spotpreis wurde gestoppt",
  "app_messages.spot_stop_discharging_battery": "Das Entladen der Batterie ins Netz gemäß Spotpreis wurde gestoppt",
  "app_messages.test": "Testbenachrichtigung",
  "app_messages.title": "Alle Nachrichten löschen",
  "app_messages.utility_loss_start": "Wir haben einen Stromausfall erkannt",
  "app_messages.utility_loss_stop": "Der Stromausfall wurde behoben",
  "app_messages.wallbox_limit_exceeded": "Das Ladelimit des Elektrofahrzeugs wurde überschritten",
  "app_messages.wallbox_start_charging": "Das Laden des Elektrofahrzeugs wurde gestartet",
  "app_messages.wallbox_stop_charging": "Das Laden des Elektrofahrzeugs wurde gestoppt",
  "app_update_overlay.subtitle": "Bitte warten. Nach dem Update wird die Anwendung neu gestartet und das Fenster im Browser automatisch aktualisiert",
  "app_update_overlay.title": "Update läuft",
  "audit_log.error": "Fehler beim Laden",
  "audit_log.item.author": "Autor",
  "audit_log.item.date": "Datum",
  "audit_log.item.payload": "Ereignis",
  "audit_log.item.type": "Typ",
  "audit_log.title": "Audit-Protokoll",
  "audit_log_delete.button": "Löschen",
  "audit_log_delete.cancel": "Abbrechen",
  "audit_log_delete.confirm": "Löschen",
  "audit_log_delete.confirm.title": "Möchten Sie wirklich alle Einträge im Audit-Protokoll löschen?",
  "audit_log_delete.title": "Audit-Protokoll löschen",
  "azRouters.add": "Neuen AZ-Router hinzufügen",
  "azRouters.addButton": "Hinzufügen",
  "azRouters.clientId": "Modbus ID",
  "azRouters.clientId.value": "Modbus ID: {id}",
  "azRouters.counts": "OK {ok} / Fehler {err}",
  "azRouters.empty": "Keine AZ-Router konfiguriert",
  "azRouters.name": "Name",
  "azRouters.status.error": "Fehler",
  "azRouters.status.ok": "OK",
  "azRouters.status.starting": "Wird gestartet",
  "azRouters.title": "AZ-Router",
  "bez_dodavatele.business_flexibility.title": "Geschäftliche Flexibilität",
  "bez_dodavatele.enabled": "Integration aktiviert",
  "bez_dodavatele.region": "Regionscode",
  "bez_dodavatele.title": "bezDodavatele",
  "boiler.blocking": "Heizsperre",
  "boiler.common": "Allgemeine Informationen",
  "boiler.common.phase_3": "Phase 3:",
  "boiler.common.power": "Gesamtverbrauch",
  "boiler.common.power.phase_1": "Phase 1:",
  "boiler.common.power.phase_2": "Phase 2:",
  "boiler.common.power_today": "Heutiger Verbrauch:",
  "boiler.common.power_year": "Jahresverbrauch:",
  "boiler.common.temperature": "Aktuelle Temperatur",
  "boiler.common.total": "Gesamtverbrauch",
  "boiler.settings": "Einstellungen",
  "boiler.settings.hdo": "Regelheizung im Hochtarif ausschalten",
  "boiler.settings.hdo.subtitle": "Die Zeiten für den Hochtarif müssen in den allgemeinen Einstellungen festgelegt werden",
  "boiler.settings.min_soc": "Heizsperre",
  "boiler.settings.min_soc.subtitle": "Batterieladestand, bei dem die Heizung während eines Stromausfalls gesperrt wird",
  "boiler.settings.min_soc_utility": "Heizsperre bei verfügbarem Netz",
  "boiler.settings.min_soc_utility.subtitle": "Batterieladestand, bei dem die Heizung während eines Stromausfalls gesperrt wird",
  "boiler.settings.spot-hi": "Heizung bei hohem Spotpreis sperren",
  "boiler.settings.spot-mi": "Heizung bei mittlerem Spotpreis sperren",
  "boiler.settings.temp": "Solltemperatur",
  "boiler.settings.temp.subtitle": "Eine übliche Temperatur, die immer verfügbar ist",
  "boiler.settings.temp_ek": "Temperatur aus Photovoltaik mit Elektroboiler",
  "boiler.settings.temp_ek.subtitle": "Vorwärmtemperatur, die nur bei einem niedrigen Preis gilt",
  "boiler.settings.temp_spot": "Temperatur vom Spot mit Elektroboiler",
  "boiler.settings.temp_spot.subtitle": "Vorwärmtemperatur, die nur bei einem niedrigen Preis gilt",
  "boiler.statistics": "Statistik",
  "boiler.statisticsTemp": "Boilertemperatur",
  "boiler.status": "Boilermodus",
  "boiler.status.home": "Boilermodus",
  "boiler_test_trigger.button": "Boiler testen",
  "boiler_test_trigger.button.running": "Test läuft",
  "boiler_test_trigger.subtitle": "Überprüft den korrekten Anschluss und die eingestellte Leistung des Boilers.",
  "boiler_test_trigger.title": "Boiler testen",
  "boiler_test_wizard.acknowledge.condition": "Für einen korrekten Boilertest muss der Verbrauch im Objekt konstant oder null sein. Schwankungen im Verbrauch können den Test beeinflussen. Der aktuelle Verbrauch des Objekts beträgt {power}",
  "boiler_test_wizard.acknowledge.config": "Derzeit ist der {phaseLabel} Boiler mit einer Gesamtleistung von {power} eingestellt. Diese Werte müssen gemäß dem Typenschild des Boilers eingestellt werden.",
  "boiler_test_wizard.acknowledge.confirm": "Bestätigen",
  "boiler_test_wizard.acknowledge.phase1": "1-phasig",
  "boiler_test_wizard.acknowledge.phase3": "3-phasig",
  "boiler_test_wizard.acknowledge.phase_option": "{phase}. Phase",
  "boiler_test_wizard.acknowledge.phase_select": "Wählen Sie die zu testenden Phasen aus. Nicht markierte Phasen werden übersprungen.",
  "boiler_test_wizard.acknowledge.phase_select_empty": "Wählen Sie mindestens eine Phase aus.",
  "boiler_test_wizard.acknowledge.start": "Boiler testen",
  "boiler_test_wizard.acknowledge.title": "Informationen zum Test",
  "boiler_test_wizard.result.after": "Verbrauch des Objekts nach der Aktivierung",
  "boiler_test_wizard.result.before": "Verbrauch des Objekts vor der Aktivierung",
  "boiler_test_wizard.result.close": "Schließen",
  "boiler_test_wizard.result.correct": "Korrekter Boilerverbrauch",
  "boiler_test_wizard.result.detail_toggle": "Testdetails",
  "boiler_test_wizard.result.header": "Testergebnis:",
  "boiler_test_wizard.result.phase_header": "{phase}. Phase",
  "boiler_test_wizard.result.real_power": "Geschätzte Boilerleistung",
  "boiler_test_wizard.result.rerun": "Test erneut ausführen",
  "boiler_test_wizard.result.set_power": "Eingestellte Leistung",
  "boiler_test_wizard.result.stable": "Messung war stabil",
  "boiler_test_wizard.result.title": "Testergebnis",
  "boiler_test_wizard.running.activate": "Aktivierung der Boilerphase",
  "boiler_test_wizard.running.after": "Verbrauch des Objekts beträgt {power}",
  "boiler_test_wizard.running.before": "Verbrauch des Objekts vor dem Test beträgt {power}",
  "boiler_test_wizard.running.measuring": "Messung läuft…",
  "boiler_test_wizard.running.phase": "Testphase {phase}",
  "boiler_test_wizard.running.real_power": "Geschätzte Boilerleistung beträgt {power}",
  "boiler_test_wizard.running.remaining": "Noch ca. {seconds} s",
  "boiler_test_wizard.running.reset": "Verbrauch wird zurückgesetzt",
  "boiler_test_wizard.running.result_fail": "Testphase ist nicht korrekt",
  "boiler_test_wizard.running.result_ok": "Testphase ist korrekt",
  "boiler_test_wizard.running.stable": "Verbrauch ist stabil",
  "boiler_test_wizard.running.title": "Test läuft",
  "boiler_test_wizard.running.unstable": "Messung war instabil",
  "boiler_test_wizard.title": "Boiler wird getestet",
  "cancel": "Abbrechen",
  "chart.range.this_week": "Letzte Woche",
  "chart.range.today": "Letzte 24{nbsp}Stunden",
  "chart.tooltip.active_condition.title": "Aktueller Modus:",
  "chart.tooltip.active_condition.value.battery": "Batterie",
  "chart.tooltip.active_condition.value.compressor-blocked": "Kompressor gesperrt, niedriger Batteriestand",
  "chart.tooltip.active_condition.value.cooling": "Kühlung",
  "chart.tooltip.active_condition.value.error": "Fehler",
  "chart.tooltip.active_condition.value.heating": "Heizen",
  "chart.tooltip.active_condition.value.hot-water": "Warmwasserbereitung",
  "chart.tooltip.active_condition.value.inactive": "Inaktiv",
  "chart.tooltip.active_condition.value.manual": "Manuell",
  "chart.tooltip.active_condition.value.not-connected": "Verbindung kann nicht hergestellt werden",
  "chart.tooltip.active_condition.value.not-licensed": "Nicht lizenziert",
  "chart.tooltip.active_condition.value.off": "Aus",
  "chart.tooltip.active_condition.value.overflow": "Überschuss",
  "chart.tooltip.active_condition.value.pool": "Poolheizung",
  "chart.tooltip.active_condition.value.spot": "Spot",
  "chart.tooltip.active_condition.value.time": "Zeit",
  "chart.tooltip.control_mode.title": "Gesteuert durch:",
  "chart.tooltip.control_mode.value": "{mode, select, photovoltaic {Photovoltaik} grid {Netz} spot {Spot} flexibility {Flexibilität} error {Fehler} other {{mode}} }",
  "chart.tooltip.wallbox_authorization_card_id.title": "Autorisierungskarte:",
  "charts.error.dialog.title": "Beim Laden der Statistik ist ein Fehler aufgetreten",
  "charts.mode.day": "Tag",
  "charts.mode.week": "Woche",
  "charts.mode.year": "Jahr",
  "charts.summary.value": "Gesamt {value}",
  "close": "Schließen",
  "cloud_plugs.bat": "Steuerung über Batterie",
  "cloud_plugs.battery.battery_start": "Einschalten beim Laden",
  "cloud_plugs.battery.battery_start.subtitle": "Batterieladung, die die Steckdose aktiviert",
  "cloud_plugs.battery.battery_stop": "Ausschalten beim Laden",
  "cloud_plugs.battery.battery_stop.subtitle": "Laden der Batterie, das die Steckdose ausschaltet",
  "cloud_plugs.battery.on": "Aktiv",
  "cloud_plugs.battery_charged": "Batterie geladen",
  "cloud_plugs.condition": "Bedingung",
  "cloud_plugs.condition.and": "Und",
  "cloud_plugs.condition.or": "Oder",
  "cloud_plugs.led_mode.battery.subtitle": "LED aktiv, wenn die Batterie mindestens 95% beträgt",
  "cloud_plugs.led_mode.battery.switch.title": "LED bei eingeschalteter Steckdose",
  "cloud_plugs.led_mode.battery.title": "LED bei geladener Batterie",
  "cloud_plugs.led_mode.mode": "{mode, select, unknown {---} off {Aus} switch {} power {Nach Leistung} other {Unbekannt}}",
  "cloud_plugs.led_mode.overflow.subtitle": "LED aktiv, wenn ein stabiler Überschuss auftritt",
  "cloud_plugs.led_mode.overflow.title": "LED bei Überschuss",
  "cloud_plugs.led_mode.switch.subtitle": "LED aktiv, wenn die Steckdose eingeschaltet ist",
  "cloud_plugs.led_mode.title": "LED-Signalisierung",
  "cloud_plugs.list.id": "ID",
  "cloud_plugs.list.led_mode": "LED-Signalisierung",
  "cloud_plugs.list.online": "Online",
  "cloud_plugs.list.relay": "Relais",
  "cloud_plugs.list.title": "Status",
  "cloud_plugs.overflow": "Steuerung über Überschuss",
  "cloud_plugs.overflow.help": "Einschalten der Steckdose bei definiertem Überschuss ins Netz.",
  "cloud_plugs.overflow.on": "Aktiv",
  "cloud_plugs.overflow.startPower": "Einschalten bei Netzbezug",
  "cloud_plugs.overflow.startPower.help": "Die Steckdose schaltet sich ein, wenn der Überschuss nach einer definierten Verzögerung das eingestellte Niveau erreicht. Wenn der Wert auf - 1500W und die Einschaltverzögerung auf 5 Minuten eingestellt ist, schaltet sich die Steckdose ein, wenn der Überschuss ins Netz mindestens 5 Minuten lang 1500W beträgt.",
  "cloud_plugs.overflow.startPower.subtitle": "Ein negativer Wert ist Überschuss, ein positiver Wert ist Verbrauch",
  "cloud_plugs.overflow.stopPower": "Ausschalten bei Netzbezug",
  "cloud_plugs.overflow.stopPower.help": "Die Steckdose schaltet sich aus, wenn der Verbrauch nach einer definierten Verzögerung höher als das eingestellte Niveau ist. Wenn der Wert auf 100W und die Ausschaltverzögerung auf 5 Minuten eingestellt ist, schaltet sich die Steckdose aus, wenn der Verbrauch aus dem Netz mindestens 5 Minuten lang 100W beträgt.",
  "cloud_plugs.overflow.stopPower.subtitle": "Ein negativer Wert ist Überschuss, ein positiver Wert ist Verbrauch",
  "cloud_plugs.pv_power": "Steuerung über PV-Leistung",
  "cloud_plugs.pv_power.help": "Einschalten der Steckdose bei definierter PV-Leistung.",
  "cloud_plugs.pv_power.on": "Aktiv",
  "cloud_plugs.pv_power.startPower": "Einschalten bei PV-Erzeugung",
  "cloud_plugs.pv_power.startPower.help": "Die Steckdose schaltet sich ein, wenn die PV-Leistung größer als das eingestellte Niveau ist. Wenn der Wert auf 1000W eingestellt ist, schaltet sich die Steckdose ein, wenn die PV-Leistung mindestens 1000W beträgt.",
  "cloud_plugs.pv_power.stopPower": "Ausschalten bei PV-Erzeugung",
  "cloud_plugs.pv_power.stopPower.help": "Die Steckdose schaltet sich aus, wenn die PV-Leistung unter dem eingestellten Niveau liegt. Wenn der Wert auf 500W eingestellt ist, schaltet sich die Steckdose aus, wenn die PV-Leistung weniger als 500W beträgt.",
  "cloud_plugs.time": "Steuerung nach Zeit",
  "cloud_plugs.time.on": "Aktiv",
  "cloud_plugs.title": "Steckdosen",
  "cloud_plugs.turn_off": "Ausschalten",
  "cloud_plugs.turn_on": "Einschalten",
  "dark_mode.dark": "Dunkel",
  "dark_mode.light": "Hell",
  "dark_mode.system": "System",
  "delta_green.battery_max_power_in": "Maximale Batterieleistung IN (W)",
  "delta_green.battery_max_power_out": "Maximale Batterieleistung OUT (W)",
  "delta_green.business_flexibility.title": "Geschäftliche Flexibilität",
  "delta_green.connected": "Status",
  "delta_green.enabled": "Integration aktiviert",
  "delta_green.last_messages": "Letzte Nachrichten",
  "delta_green.last_messages.date": "Zeit",
  "delta_green.last_messages.payload": "Nachricht",
  "delta_green.last_messages.topic": "Thema",
  "delta_green.pv_orientation": "Photovoltaik-Ausrichtung",
  "delta_green.title": "Delta Green",
  "des_battery_container.status.error": "Fehler",
  "des_battery_container.status.none": "Unbekannter Zustand",
  "des_battery_container.status.off": "Aus",
  "des_battery_container.status.run": "Normalbetrieb",
  "des_battery_container.status.sleep": "Schlafmodus",
  "dev.cloud_plugs.mqtt_cloud.connected": "MQTT-Cloud-Verbindungsstatus",
  "dev.cloud_plugs.title": "Cloud-Steckdosen",
  "dev.inverter_config.connection.lan": "LAN",
  "dev.inverter_config.connection.rs485": "RS485",
  "dev.inverter_config.connection.rs485_hint": "Adresse und Port werden von der Platine übernommen ({host}:{port}).",
  "dev.inverter_config.rename_warning": "Das Umbenennen des Schlüssels von \"{from}\" in \"{to}\" macht historische Daten verwaist — Statistiken und geladene erzeugte Energie, die unter dem ursprünglichen Schlüssel geführt werden.",
  "dev.inverter_config.search.open": "Wechselrichter suchen",
  "dev.inverter_config.search.title": "Wechselrichter suchen",
  "dev.inverter_config.stats.all": "Alle",
  "dev.inverter_config.status.counts": "OK {ok} / Fehler {err}",
  "dev.inverter_config.status.error": "Fehler",
  "dev.inverter_config.status.ok": "OK",
  "dev.inverter_config.status.starting": "Wird gestartet",
  "dev.inverter_config.title": "Wechselrichterkonfiguration",
  "dev.link": "Dev",
  "dev_app_messages.test_send": "Testbenachrichtigung",
  "dev_app_messages.test_send.button": "Senden",
  "dev_homepage.app_messages.title": "Benachrichtigungen",
  "dev_homepage.title": "Entwicklungsmenü",
  "dev_spot.summary.title": "Modusübersicht",
  "dev_spot.title": "Spot (Entwicklung)",
  "dev_status_log.empty": "Noch keine Daten",
  "dev_status_log.error": "Fehler beim Laden",
  "dev_status_log.title": "Statusprotokoll",
  "dev_status_log.today": "Heute",
  "dhcp_host.address": "IP-Adresse",
  "dhcp_host.create.title": "Neuer DHCP-Host",
  "dhcp_host.edit.title": "DHCP-Host bearbeiten",
  "dhcp_host.mac": "MAC-Adresse",
  "dhcp_host.name": "Name",
  "dhcp_hosts.remove.cancel": "Abbrechen",
  "dhcp_hosts.remove.confirm": "Löschen",
  "dhcp_hosts.remove.confirm.title": "Möchten Sie die feste DHCP-Hostadresse wirklich aufheben?",
  "dhcp_leases.ip": "IP-Adresse",
  "dhcp_leases.mac": "MAC-Adresse",
  "dhcp_leases.make_static.cancel": "Abbrechen",
  "dhcp_leases.make_static.confirm": "Hinzufügen",
  "dhcp_leases.make_static.confirm.title": "Möchten Sie die DHCP-Hostadresse wirklich festlegen?",
  "dhcp_leases.name": "Name",
  "dhcp_leases.next_renewal": "Nächste Verlängerung",
  "dhcp_leases.title": "DHCP-Leases",
  "ean": "EAN",
  "electree.business_flexibility.title": "Geschäftliche Flexibilität",
  "electree.connected": "Status",
  "electree.enabled": "Integration aktiviert",
  "electree.last_messages": "Letzte Nachrichten",
  "electree.last_messages.date": "Zeit",
  "electree.last_messages.payload": "Nachricht",
  "electree.last_messages.topic": "Thema",
  "electree.title": "Electree",
  "electrical_grid.common": "Allgemeine Informationen",
  "electrical_grid.common.overflow": "Gesamtfluss ins Netz",
  "electrical_grid.common.overflow_today": "Heutiger Überschuss ins Netz:",
  "electrical_grid.common.overflow_year": "Jährlicher Überschuss ins Netz:",
  "electrical_grid.common.power": "Gesamtverbrauch aus dem Netz",
  "electrical_grid.common.power.phase_1": "Phase 1:",
  "electrical_grid.common.power.phase_2": "Phase 2:",
  "electrical_grid.common.power.phase_3": "Phase 3:",
  "electrical_grid.common.power_today": "Heutiger Verbrauch aus dem Netz:",
  "electrical_grid.common.power_year": "Jahresverbrauch aus dem Netz:",
  "electrical_grid.common.total_consumption": "Gesamtverbrauch aus dem Netz",
  "electrical_grid.statistics": "Bezugsstatistik",
  "electrical_grid.statistics_overflow": "Überschussstatistik",
  "electrical_grid.status": "Netzstatus",
  "ems.activePower": "Wirkleistung",
  "ems.apparentPower": "Scheinleistung",
  "ems.details": "Wechselrichterparameter",
  "ems.inverter": "Wechselrichter",
  "ems.inverter.index": "Wechselrichter {index}",
  "ems.inverter.mode.backup": "Notstrom",
  "ems.inverter.mode.feedIn": "Einspeisung",
  "ems.inverter.mode.manual": "Manuell",
  "ems.inverter.mode.peakShaving": "Spitzenlastkappung",
  "ems.inverter.mode.selfUse": "Eigenverbrauch",
  "ems.inverter.name": "Name des Wechselrichters",
  "ems.inverter.name.aelio": "X3-AELIO",
  "ems.inverter.name.notConnected": "Nicht verbunden",
  "ems.inverter.name.trene100k": "X3-TRENE-100K",
  "ems.inverter.name.trene100ki": "X3-TRENE-100KI",
  "ems.inverter.name.trene125k": "X3-TRENE-125K",
  "ems.inverter.name.unknown": "Unbekanntes Modell",
  "ems.mode": "EMS-Modus",
  "ems.power.index": "Leistung {index}",
  "ems.power.total": "Gesamtleistung",
  "ems.powerFactor": "Leistungsfaktor",
  "ems.reactivePower": "Blindleistung",
  "ems.status": "Status",
  "emsPro.inverter.name.aelio": "X3-AELIO",
  "emsPro.inverter.name.notConnected": "Nicht verbunden",
  "emsPro.inverter.name.trene1": "X3-TRENE-1",
  "emsPro.inverter.name.trene100k": "X3-TRENE-100K",
  "emsPro.inverter.name.trene125k": "X3-TRENE-125K",
  "emsPro.inverter.name.x3forth": "X3-FORTH",
  "emsPro.inverter.name.x3forthplus": "X3-FORTH+",
  "emsPro.inverter.name.x3grand": "X3-GRAND",
  "emsPro.inverter.name.x3mgag2": "X3-MGA G2",
  "emsPro.inverter.name.x3prog2": "X3-PRO G2",
  "emsService.basicSettings": "Grundeinstellungen",
  "emsService.direction.disabled": "Deaktiviert",
  "emsService.direction.read": "Lesen",
  "emsService.direction.write": "Schreiben",
  "emsService.distributionMetrics": "Verteilnetzbefehle",
  "emsService.distributionMetrics.diMapping": "Eingangszuordnung",
  "emsService.distributionMetrics.enabled": "Lesen von Verteilnetzbefehlen aktivieren",
  "emsService.distributionMetrics.source": "Quelle der Verteilnetzbefehle",
  "emsService.distributionMetrics.source.digitalInputs": "Digitaleingänge",
  "emsService.distributionMetrics.source.plc": "Externe PLC",
  "emsService.enabled": "PLC aktiviert",
  "emsService.energyMeters": "Energiezähler",
  "emsService.energyMeters.add": "Neuen Energiezähler hinzufügen",
  "emsService.energyMeters.addButton": "Hinzufügen",
  "emsService.energyMeters.azRouter": "AZ-Router",
  "emsService.energyMeters.azRouter.empty": "Keine AZ-Router konfiguriert",
  "emsService.energyMeters.empty": "Keine Energiezähler konfiguriert",
  "emsService.energyMeters.newMeter": "Name",
  "emsService.energyMeters.plcMetric": "PLC-Metrik",
  "emsService.energyMeters.plcMetric.grid": "Netz",
  "emsService.energyMeters.plcMetric.kgj": "KGJ",
  "emsService.energyMeters.plcMetric.pv": "PV",
  "emsService.energyMeters.shellyId": "Shelly ID",
  "emsService.energyMeters.source": "Quelle",
  "emsService.energyMeters.source.azRouter": "AZ-Router",
  "emsService.energyMeters.source.plc": "PLC",
  "emsService.energyMeters.source.shelly": "Shelly",
  "emsService.gridMetrics.enabled": "Lesen der Netzmetriken aktiviert",
  "emsService.ipAddress": "IP-Adresse",
  "emsService.kgjMetrics": "KGJ-Metriken",
  "emsService.kgjMetrics.enabled": "Lesen der KGJ-Metriken aktiviert",
  "emsService.metricsDirection": "Richtung",
  "emsService.metricsEnabled": "Aktiviert",
  "emsService.mqttBroker": "MQTT-Broker (Shellies)",
  "emsService.mqttBrokerEnabled": "MQTT-Broker aktiviert",
  "emsService.mqttBrokerStatus": "MQTT-Broker-Status",
  "emsService.notAvailable": "Die EMS-Funktion ist nicht verfügbar",
  "emsService.password": "Passwort",
  "emsService.plcStatus": "PLC-Kommunikationsstatus",
  "emsService.pollInterval": "Abfrageintervall (ms)",
  "emsService.pvMetrics": "PV-Metriken",
  "emsService.pvMetrics.enabled": "Lesen der PV-Metriken aktiviert",
  "emsService.pvMetrics.meterId": "Energiezähler",
  "emsService.pvMetrics.meterSource": "Datenquelle",
  "emsService.pvMetrics.meterSource.meter": "Energiezähler",
  "emsService.pvMetrics.meterSource.plc": "PLC",
  "emsService.shelliesList": "Verbundene Shelly-Geräte",
  "emsService.username": "Benutzername",
  "ems_service.link": "EMS-Service",
  "ems_service.title": "EMS-Service",
  "enerco.ean": "EAN",
  "enerco.enabled": "Integration aktiviert",
  "enerco.prediction.disabled": "Die Integration ist deaktiviert.",
  "enerco.prediction.title": "Prognose",
  "enerco.title": "Enerco",
  "energomachine.business_flexibility.title": "Geschäftliche Flexibilität",
  "energomachine.connected": "Status",
  "energomachine.enabled": "Integration aktiviert",
  "energomachine.last_messages": "Letzte Nachrichten",
  "energomachine.last_messages.date": "Zeit",
  "energomachine.last_messages.payload": "Nachricht",
  "energomachine.last_messages.topic": "Thema",
  "energomachine.title": "Energomachine",
  "energyMeters.actualPower": "Aktuelle Leistung",
  "energyMeters.general": "Allgemeine Informationen",
  "energyMeters.meter": "Energiezähler",
  "energyMeters.notConfigured": "Energiezähler sind nicht konfiguriert. Gehen Sie zum Servicemenü, um sie einzurichten.",
  "energyMeters.phase1": "Phase 1:",
  "energyMeters.phase2": "Phase 2:",
  "energyMeters.phase3": "Phase 3:",
  "energyMeters.statistics": "Statistik",
  "energyMeters.todayEnergy": "Heutiger Verbrauch:",
  "energyMeters.totalEnergy": "Gesamtverbrauch",
  "energyMeters.yearEnergy": "Jahresverbrauch:",
  "error": "Fehler beim Laden des Berichts.",
  "expertService.EM": "Energiezähler",
  "expertService.EM.add": "Hinzufügen",
  "expertService.EM.empty": "Keine Energiezähler konfiguriert",
  "expertService.EM.list": "Konfiguration der Energiezähler",
  "expertService.EM.name": "Name",
  "expertService.EM.newMeter": "Neuer Zähler",
  "expertService.EM.shellyId": "Shelly ID",
  "expertService.HP": "Wärmepumpe",
  "expertService.HP.CntComErr": "Zähler für Fehlernachrichten",
  "expertService.HP.CntComOk": "Zähler für gültige Nachrichten",
  "expertService.HP.IpAdr": "IP-Adresse der Wärmepumpe",
  "expertService.HP.maxTempHW": "Maximale Warmwassertemperatur für die Wärmepumpe",
  "expertService.HP.maxTempHW.subtitle": "Summe aus flexibler + eingestellter Temperatur",
  "expertService.HW": "Warmwasser",
  "expertService.HW.HwBatteryPriority": "Batterieladestand in Prozent, ab dem der Boiler immer Priorität hat",
  "expertService.HW.HwErrEnabled": "Verfügbarkeit des Boilers auswerten",
  "expertService.HW.HwResetErrorTime": "Verzögerung für das Zurücksetzen des Thermostatfehlers",
  "expertService.HW.HwResetErrorTime.subtitle": "Zeit in Minuten, nach der der Thermostatfehler zurückgesetzt wird und die Warmwasserbereitung erneut startet",
  "expertService.HW.LegionellaLastTime": "Letztes Erreichen der Legionellentemperatur",
  "expertService.HW.TempId": "ID des Temperatursensors",
  "expertService.HW.control": "Steuerungstyp des Boilers",
  "expertService.HW.control.onoff": "Ein/Aus",
  "expertService.HW.control.proportional": "Proportional",
  "expertService.HW.hysterezis": "Hysterese Warmwasser",
  "expertService.HW.hysterezis.subtitle": "Die Hysterese gilt nur für die reguläre Warmwasserbereitung",
  "expertService.HW.maxPower": "Maximale Leistung des Boilers in Prozent",
  "expertService.HW.maxPower.subtitle": "Diese Einstellung gilt nur für die stufenlose Steuerung des Boilers und begrenzt die maximale Leistung des Heizstabs in Prozent.",
  "expertService.HW.offset": "Phasenoffset [W]",
  "expertService.HW.offset.disabled-overflow": "Offset für die Steuerung des Boilers bei deaktiviertem Überschuss auf der Phase [W]",
  "expertService.HW.offset.disabled-overflow.subtitle": "Ein höherer Wert ermöglicht dem Boiler, mehr Energie aus dem Netz zu beziehen, wenn der Überschuss deaktiviert ist",
  "expertService.HW.offset.enabled-overflow": "Offset für die Steuerung des Boilers bei aktiviertem Überschuss auf der Phase [W]",
  "expertService.HW.offset.enabled-overflow.subtitle": "Ein höherer Wert ermöglicht dem Boiler, mehr Energie aus dem Netz zu beziehen.",
  "expertService.HW.offset.ongrid": "Offset für die Steuerung des Boilers mit Netzleistung [W]",
  "expertService.HW.offset.ongrid.subtitle": "Ein höherer Wert ermöglicht dem Boiler, mehr Energie aus dem Netz zu beziehen.",
  "expertService.PV": "Photovoltaik",
  "expertService.PV.BatteryPowerPercent": "Ladeleistung der Batterie in Prozent",
  "expertService.PV.CntComErr": "Zähler für Fehlernachrichten",
  "expertService.PV.CntComOk": "Zähler für gültige Nachrichten",
  "expertService.PV.ControlMeteringMode": "Methode der Überschussregelung",
  "expertService.PV.ControlMeteringMode.perPhase": "Pro Phase",
  "expertService.PV.ControlMeteringMode.subtitle": "Die phasenweise Regelung berechnet den Überschuss für die Gerätesteuerung aus den einzelnen Phasen. Die Summenregelung arbeitet mit der Summe aller Phasen.",
  "expertService.PV.ControlMeteringMode.sum": "Summiert",
  "expertService.PV.ExternalPv": "Externe PV, angeschlossen über SOLAX Meter 2",
  "expertService.PV.ExternalPvSofar": "Externe PV, angeschlossen über SOFAR Meter 2",
  "expertService.PV.IpAdr": "IP-Adresse des Wechselrichters",
  "expertService.PV.MeteringMode": "Messverfahren des Netzes",
  "expertService.PV.MeteringMode.perPhase": "Pro Phase",
  "expertService.PV.MeteringMode.subtitle": "Die phasenweise Zählung (CZ) erfasst Bezug und Einspeisung auf jeder Phase getrennt. Die Summenzählung arbeitet mit der Nettobilanz aller Phasen.",
  "expertService.PV.MeteringMode.sum": "Summiert",
  "expertService.PV.PowerControlType": "Leistungsregelungstyp des Netzwechselrichters",
  "expertService.PV.PowerControlType.fixed": "Fest",
  "expertService.PV.PowerControlType.proportional": "Proportional",
  "expertService.PV.StringNumber": "Anzahl der Strings des Wechselrichters",
  "expertService.PV.StringNumber.subtitle": "Anzahl der Strings des Wechselrichters, die in der Anwendung auf der PV-Registerkarte angezeigt werden",
  "expertService.PV.Versions": "Version",
  "expertService.SP": "Spot",
  "expertService.SP.HwCoefficient": "Koeffizient für die Energieschätzung des Boilers",
  "expertService.SP.HwCoefficient.subtitle": "Koeffizient der geschätzten Energie zum Laden des Boilers.",
  "expertService.SP.MinDifferencePriceChargeFromGrid": "Minimale Spotpreisdifferenz für das Laden der Batterie aus dem Netz",
  "expertService.SP.batteryCoefficient": "Koeffizient für die Schätzung der Batterieladezeit",
  "expertService.SP.batteryCoefficient.subtitle": "Koeffizient der geschätzten Zeit zum Laden der Batterie",
  "expertService.SP.minDifferenceBatterychargeFromGrid": "Minimale geschätzte SOC-Zunahme für das Warten auf PV",
  "expertService.SP.minDifferenceBatterychargeFromGrid.subtitle": "Wenn die geschätzte Batterieladung unter diesem Wert liegt, kann die Batterie aus dem Netz geladen werden.",
  "expertService.WB": "Wallbox",
  "expertService.WB.CntComErr": "Zähler für Fehlernachrichten",
  "expertService.WB.CntComOk": "Zähler für gültige Nachrichten",
  "expertService.WB.IpAdr": "IP-Adresse der Wallbox",
  "expertService.general": "Allgemeine Einstellungen",
  "expertService.general.largeInstallation": "Große Installation",
  "expertService.general.largeInstallation.subtitle": "Erweitert den Wertebereich für große Installationen",
  "expertService.password": "Servicezugang",
  "expertService.password.label": "Passwort",
  "expert_service.app_messages": "Nachrichten",
  "expert_service.audit_log": "Audit-Protokoll",
  "expert_service.error_list": "Fehlerliste",
  "expert_service.link": "Experten-Service",
  "expert_service.network": "Netzwerk",
  "expert_service.network.button": "Zu den Netzwerkeinstellungen",
  "expert_service.network.link": "Netzwerk",
  "expert_service.reports": "Berichte",
  "expert_service.stats": "Statistik",
  "expert_service.title": "Service",
  "expert_service.xyz": "Service",
  "header.title": "Startseite",
  "header.title.app_messages": "Nachrichten",
  "header.title.audit_log": "Audit-Protokoll",
  "header.title.boiler": "Boiler",
  "header.title.cloud_plugs": "Steckdosen",
  "header.title.dev": "Netzwerkeinstellungen",
  "header.title.dev.app_messages": "Benachrichtigungen",
  "header.title.dev.az_routers": "AZ-Router",
  "header.title.dev.bez_dodavatele": "bezDodavatele",
  "header.title.dev.cloud_plugs": "Cloud-Steckdosen",
  "header.title.dev.delta_green": "Delta Green",
  "header.title.dev.electree": "Electree",
  "header.title.dev.enerco": "Enerco",
  "header.title.dev.energomachine": "Energomachine",
  "header.title.dev.inverter_config": "Wechselrichterkonfiguration",
  "header.title.dev.mqtt_broker": "MQTT-Broker",
  "header.title.dev.mqtt_cloud": "MQTT Cloud",
  "header.title.dev.pre_flexibility": "PRE Flexibilität",
  "header.title.dev.scripts": "Skripte",
  "header.title.dev.shellies": "Shellies",
  "header.title.dev.spot": "Spot",
  "header.title.dev.status_log": "Statusprotokoll",
  "header.title.dev.subscriptions": "Abonnements",
  "header.title.dev_homepage": "Entwicklungsmenü",
  "header.title.ems": "EMS",
  "header.title.ems_service": "EMS-Service",
  "header.title.energyMeters": "Energiezähler",
  "header.title.expert_service": "Experten-Service",
  "header.title.expert_service.network": "Netzwerkeinstellungen",
  "header.title.grid": "Netz",
  "header.title.heat_pump": "Wärmepumpe",
  "header.title.photovoltaics": "Photovoltaik",
  "header.title.plug": "Steckdose",
  "header.title.relay": "Relais",
  "header.title.reports": "Berichte",
  "header.title.rfid_cards": "RFID-Karten",
  "header.title.settings": "Einstellungen",
  "header.title.spot": "Spot",
  "header.title.statistics": "Statistik",
  "header.title.thermostat": "Thermostat",
  "header.title.wallbox": "Wallbox",
  "header.title.wallbox_list": "Wallboxen",
  "header.title.wind": "Windkraftanlage",
  "heat_pump.HW": "Warmwasserbereitung",
  "heat_pump.HW.actual_temp": "Aktuelle Speichertemperatur",
  "heat_pump.HW.flexitemp": "Flexible Temperatur",
  "heat_pump.HW.flexitemp.subtitle": "Temperatur, um die das Warmwasser vorgeheizt werden kann",
  "heat_pump.HW.hysteresis": "Hysterese der Warmwasserbereitung",
  "heat_pump.HW.on": "Warmwasserbereitung",
  "heat_pump.HW.temp": "Gewünschte Boilertemperatur",
  "heat_pump.acond": "Acond",
  "heat_pump.blocked": "Kompressorsperre",
  "heat_pump.blocked.min_soc": "Kompressorsperre",
  "heat_pump.blocked.min_soc_utility": "Kompressorsperre bei verfügbarem Netz",
  "heat_pump.blocked.subtitle": "Batterieladestand, bei dem der Kompressor während eines Stromausfalls gesperrt wird",
  "heat_pump.common": "Allgemeine Informationen",
  "heat_pump.common.power": "Gesamtverbrauch",
  "heat_pump.common.power_today": "Heutiger Verbrauch:",
  "heat_pump.common.power_year": "Jahresverbrauch:",
  "heat_pump.common.temp": "Aktuelle Temperatur am Wärmetauscher",
  "heat_pump.common.total": "Gesamtverbrauch",
  "heat_pump.ecoone": "Ecoone",
  "heat_pump.flexi": "Energieflexibilität",
  "heat_pump.flexi.flexi_on": "Flexibilitätsmodus",
  "heat_pump.flexi.flexi_on.subtitle": "Der Modus aktiviert das Vorheizen aus überschüssiger Energie",
  "heat_pump.flexi.pvstability": "Potenzial für die Kompressoraktivierung",
  "heat_pump.flexi_sp": "Spotflexibilität",
  "heat_pump.flexi_sp.flexi_increase_on": "Verbrauch erhöhen",
  "heat_pump.flexi_sp.flexi_increase_on.subtitle": "Der Modus ermöglicht eine Erhöhung des Verbrauchs bei niedrigen Energiepreisen",
  "heat_pump.flexi_sp.flexi_reduce_on": "Verbrauch verzögern",
  "heat_pump.flexi_sp.flexi_reduce_on.subtitle": "Der Modus ermöglicht ein Verschieben des Verbrauchs bei hohen Energiepreisen",
  "heat_pump.nibe": "Nibe",
  "heat_pump.room": "Heizung",
  "heat_pump.room.equithermalCorrection": "Anpassung der Heizkurve",
  "heat_pump.room.flexitemp": "Flexible Temperatur",
  "heat_pump.room.flexitemp.subtitle": "Temperatur, um die das Haus vorgeheizt oder vorgekühlt werden kann",
  "heat_pump.room.on": "Heizung",
  "heat_pump.room.tem": "Gewünschte Temperatur",
  "heat_pump.room.temp": "Aktuelle Raumtemperatur",
  "heat_pump.room.tempmax": "Gewünschte Komforttemperatur",
  "heat_pump.room.tempmin": "Gewünschte Absenktemperatur",
  "heat_pump.room_cool.on": "Kühlung",
  "heat_pump.status": "Heizmodus",
  "heat_pump_wizard.cancel": "Abbrechen",
  "heat_pump_wizard.ip_address.alert": "Bitte stellen Sie sicher, dass sich die IP-Adresse der Wärmepumpe nicht ändert (z. B. wenn die Wärmepumpe eine Adresse von DHCP verwendet).",
  "heat_pump_wizard.ip_address.input": "IP-Adresse der Wärmepumpe",
  "heat_pump_wizard.open": "Typ der Wärmepumpe einrichten",
  "heat_pump_wizard.save": "Speichern",
  "heat_pump_wizard.title": "Einstellungen der Wärmepumpe",
  "heatpump.statistics": "Statistik",
  "heatpump.status": "Wärmepumpenmodus",
  "home.premium.banner.inactive.subtitle": "Infigy Plus bietet detailliertere Diagramme, monatliche Berichte, Benachrichtigungen und vieles mehr.",
  "home.premium.banner.inactive.title": "Möchten Sie einen besseren Überblick?",
  "homepage.actual.battery": "Batteriestatus",
  "homepage.actual.boiler": "Boiler",
  "homepage.actual.outdoor_temperature": "Außentemperatur",
  "homepage.actual.thermostat": "Thermostat",
  "homepage.actual.title": "",
  "homepage.animation": "Aktuell",
  "homepage.statuses.title": "Aktive Komponentenmodi",
  "homepage.statuses.tooltip": "Aktive Komponentenmodi",
  "homepage.today.consumed": "Hausverbrauch",
  "homepage.today.consumed_WB": "Wallbox",
  "homepage.today.consumed_from_grid": "Verbrauch aus dem Netz",
  "homepage.today.consumed_hp": "Wärmepumpe",
  "homepage.today.consumed_hw": "Warmwasser",
  "homepage.today.overflow": "Überschuss ins Netz",
  "homepage.today.photovoltaics": "Photovoltaikerzeugung",
  "homepage.today.title": "Tagesstatistik",
  "homepage.today.wind": "Erzeugung der Windkraftanlage",
  "hp.status.compressor_blocked": "Kompressorsperre, niedriger Batteriestand",
  "hp.status.cooling": "Kühlung",
  "hp.status.heating": "Heizung",
  "hp.status.hot_water": "Warmwasserbereitung",
  "hp.status.inactive": "Inaktiv",
  "hp.status.not_connected": "Verbindung kann nicht hergestellt werden",
  "hp.status.not_licensed": "Wärmepumpe ist nicht lizenziert",
  "hp.status.pool": "Poolheizung",
  "hp.sub_status.consumption_postpone": "bei reduziertem Verbrauch",
  "hp.sub_status.consumption_rise": "bei erhöhtem Verbrauch",
  "hp.sub_status.consumption_with_flexibility": "mit Flexibilität",
  "hp.sub_status.nibe_not_writable": "- Schreiben auf NIBE nicht möglich",
  "hp.sub_status.none": "",
  "initial_wizard.banner.button": "Assistenten starten",
  "initial_wizard.banner.hide.confirm": "Möchten Sie den Assistenten wirklich ausblenden?",
  "initial_wizard.banner.hide.confirm.description": "Sie können den Assistenten jederzeit in den Anwendungseinstellungen erneut starten.",
  "initial_wizard.banner.hide.show_more": "Assistenten starten",
  "initial_wizard.banner.hide.yes": "Ausblenden",
  "initial_wizard.banner.subtitle": "Der Assistent hilft Ihnen, die grundlegenden Parameter Ihres Systems einzurichten.",
  "initial_wizard.banner.title": "Erstkonfiguration abschließen",
  "initial_wizard.banner.title.completed": "Erstkonfiguration abschließen",
  "initial_wizard.dialog.finish": "Fertigstellen",
  "initial_wizard.dialog.next": "Weiter",
  "initial_wizard.dialog.prev": "Zurück",
  "initial_wizard.dialog.step": "Schritt {current} von {total}",
  "initial_wizard.dialog.title": "Assistent für die Erstkonfiguration",
  "initial_wizard.step1.description.active": "Ihr Zugang zum Service ist bereits aktiv. Sie können mit dem nächsten Schritt fortfahren.",
  "initial_wizard.step1.password_info": "Jedes Unternehmen hat ein eigenes Zugangspasswort zum Servicemenü. Sie haben das Passwort per E-Mail erhalten. Sie können es auch jederzeit unter app.infigy.cz im Partnerbereich einsehen.",
  "initial_wizard.step1.title": "Zugang zum Service",
  "initial_wizard.step1.welcome": "Willkommen bei der Erstkonfiguration von Infigy. Wir führen Sie durch die Grundkonfiguration Ihres Systems. Detaillierte Einstellungen finden Sie anschließend im Servicemenü.",
  "initial_wizard.step10.title": "Wallbox-Einstellungen",
  "initial_wizard.step11.description": "Sie haben die Grundeinstellung von Infigy abgeschlossen. Alle Parameter können im Servicemenü bearbeitet werden.",
  "initial_wizard.step11.service_menu.subtitle": "Einstellungen -> ganz nach unten -> Zugang zum Service",
  "initial_wizard.step11.service_menu.title": "Servicemenü",
  "initial_wizard.step11.title": "Fertig",
  "initial_wizard.step2.title": "Aktualisierung der Anwendung",
  "initial_wizard.step3.title": "Installation",
  "initial_wizard.step4.title": "Einstellungen des Hauptleistungsschalters",
  "initial_wizard.step5.title": "Wechselrichteranschluss",
  "initial_wizard.step6.title": "Wechselrichterparameter",
  "initial_wizard.step7.description": "Wenn der Überschuss ins Netz begrenzt ist, werden die Einstellungen an den Wechselrichter übertragen. Die Begrenzung der Überschüsse übernimmt der Wechselrichter. Infigy steuert den Wert jedoch gemäß dem in diesem Feld festgelegten Wert. Ändern Sie das Überschusslimit nicht im Wechselrichter. Bei der Ersteinrichtung prüfen Sie den im Wechselrichter geschriebenen Wert, ob er korrekt von Infigy an den Wechselrichter übertragen wurde.",
  "initial_wizard.step7.title": "Überschusslimit",
  "initial_wizard.step8.title": "Boiler-Einstellungen",
  "initial_wizard.step9.title": "Einstellungen für den Spot-Handel",
  "initial_wizard.step_app_update.description": "Während Infigy zu Ihnen unterwegs war, konnten wir neue Versionen der Anwendung veröffentlichen. Wir empfehlen, das Gerät vor der Einrichtung zu aktualisieren. Wenn jedoch beispielsweise kein Internet verfügbar ist, können Sie die Aktualisierung überspringen und sie später im Servicemenü oder im Portal durchführen.",
  "inverter.3mar_plc": "3Mar PLC",
  "inverter.az_router": "AzRouter-Energiezähler",
  "inverter.control.mode": "Wechselrichtersteuerung",
  "inverter.control.mode.chargingFromGrid": "Laden der Batterie aus dem Netz",
  "inverter.control.mode.dischargingToGrid": "Entladen der Batterie ins Netz",
  "inverter.control.mode.noneControl": "Keine Steuerung",
  "inverter.control.mode.stopCharging": "Laden stoppen",
  "inverter.control.mode.stopDischarging": "Entladen stoppen",
  "inverter.control.mode.stopOverflow": "Überschuss stoppen",
  "inverter.des_battery_container": "DES – Containerspeicher",
  "inverter.deye": "Deye LV",
  "inverter.deye_hv": "Deye HV",
  "inverter.fronius": "Fronius SYMO GEN24",
  "inverter.fronius_grid": "Fronius SYMO Netz",
  "inverter.fronius_verto": "Fronius Verto",
  "inverter.good_we": "GoodWe",
  "inverter.good_we_grid_next": "GoodWe Netz",
  "inverter.good_we_next": "GoodWe",
  "inverter.goodwe-Grid": "Goodwe netzgekoppelt",
  "inverter.goodwe_grid": "Goodwe Netz",
  "inverter.hes": "HES – Batteriespeicher",
  "inverter.next": "Weitere Wechselrichter",
  "inverter.none": "Keine",
  "inverter.sermatec": "Sermatec",
  "inverter.shellies": "Shellies",
  "inverter.shellies_external": "Shellies Extern",
  "inverter.sma_grid": "SMA Netz",
  "inverter.sofar_solar": "Sofarsolar",
  "inverter.sofar_solar_rs485": "SofarSolar RS485",
  "inverter.solar_edge_grid": "SolarEdge netzgekoppelt",
  "inverter.solax": "Solax",
  "inverter.solax-Grid": "Solax netzgekoppelt",
  "inverter.solax_ems1000": "Solax EMS1000",
  "inverter.solax_ems1000pro": "Solax EMS1000PRO",
  "inverter.solax_grid": "Solax netzgekoppelt",
  "inverter.solax_mega_grid": "Solax MEGA/FORTH netzgekoppelt",
  "inverter.solax_mic_grid": "Solax MIC netzgekoppelt",
  "inverter.solax_next": "SolaxNext",
  "inverter.solinteg": "Solinteg",
  "inverter.victron": "Victron",
  "inverter.wattsonic": "Wattsonic",
  "inverter_wizard.cancel": "Abbrechen",
  "inverter_wizard.custom_device_ip_address.alert": "Bitte stellen Sie sicher, dass sich die IP-Adresse des Wechselrichters nicht ändert (z. B. wenn der Wechselrichter eine Adresse von DHCP verwendet).",
  "inverter_wizard.custom_device_ip_address.input": "IP-Adresse des Wechselrichters",
  "inverter_wizard.multiple_inverters.alert": "Bitte kontaktieren Sie die Support-Hotline für die Einrichtung mehrerer Wechselrichter. Den Kontakt finden Sie im technischen Wiki von Infigy.",
  "inverter_wizard.multiple_inverters.label": "Mehrere Wechselrichter",
  "inverter_wizard.multiple_inverters_or_ems.alert": "Ihr System verfügt bereits über Einstellungen für mehrere Wechselrichter oder EMS. Dieser Assistent ist nur für die Einrichtung eines Wechselrichters vorgesehen. Für Änderungen an den Einstellungen von Wechselrichtern oder EMS wenden Sie sich bitte an den Support.",
  "inverter_wizard.nominal_power": "Nennleistung des Wechselrichters",
  "inverter_wizard.nominal_power.helper": "Bereich: 1 bis 100 kW",
  "inverter_wizard.nominal_power.validation": "Geben Sie die Nennleistung des Wechselrichters in kW ein.",
  "inverter_wizard.open": "Wechselrichter finden",
  "inverter_wizard.save": "Speichern",
  "inverter_wizard.scan": "Wechselrichter im Netzwerk finden",
  "inverter_wizard.scanning": "Suche nach Wechselrichter im Netzwerk",
  "inverter_wizard.submit_error": "Beim Speichern der Wechselrichtereinstellungen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  "inverter_wizard.title": "Assistent zum Anschluss des Wechselrichters",
  "layout.disconnected": "Getrennt",
  "layout.pigpio_init_error_dialog.description": "Die Infigy-Anwendung wurde nicht korrekt gestartet. Bitte starten Sie das Gerät neu und kontaktieren Sie den Support, falls das Problem weiterhin besteht.",
  "layout.pigpio_init_error_dialog.title": "Fehler beim Starten der Anwendung",
  "level.thermostat.cooling": "Kühlung",
  "level.thermostat.deactivated": "Deaktiviert",
  "level.thermostat.heating": "Heizung",
  "level.thermostat.standby": "Standby",
  "level.thermostat.tempErr": "Temperaturfehler",
  "level.thermostatFlexibility.increasePv": "Flexibilität zur Temperaturerhöhung gemäß Photovoltaik genutzt",
  "level.thermostatFlexibility.increaseSpot": "Flexibilität zur Temperaturerhöhung gemäß SPOT genutzt",
  "level.thermostatFlexibility.normal": "Normal",
  "level.thermostatFlexibility.reductionSpot": "Flexibilität zur Temperatursenkung gemäß SPOT genutzt",
  "mqtt_broker.connected_clients.title": "Clients",
  "mqtt_broker.enabled": "Aktiviert",
  "mqtt_broker.running": "Status",
  "mqtt_broker.title": "MQTT-Broker",
  "mqtt_cloud.connected": "Status",
  "mqtt_cloud.connected.offline": "Offline",
  "mqtt_cloud.connected.online": "Online",
  "mqtt_cloud.enabled": "Integration aktiviert",
  "mqtt_cloud.title": "MQTT Cloud",
  "nav.app_messages": "Nachrichten",
  "nav.home": "Startseite",
  "nav.logout": "Abmelden",
  "nav.reports": "Berichte",
  "nav.sec.boiler": "Boiler",
  "nav.sec.cloud_plugs": "Steckdosen",
  "nav.sec.ems": "EMS",
  "nav.sec.energyMeters": "Energiezähler",
  "nav.sec.grid": "Netz",
  "nav.sec.heatpump": "Wärmepumpe",
  "nav.sec.home": "Allgemein",
  "nav.sec.photovoltaics": "Photovoltaik",
  "nav.sec.plug": "Steckdose",
  "nav.sec.relay": "Relais",
  "nav.sec.spot": "Spot",
  "nav.sec.thermostat": "Thermostat",
  "nav.sec.wallbox": "Wallbox",
  "nav.sec.wind": "Windkraftanlage",
  "nav.settings": "Einstellungen",
  "nav.statistics": "Statistik",
  "network.ethernet_ports": "Ethernet-Ports",
  "network.ethernet_ports.name": "LAN",
  "network.ethernet_ports.status": "Status",
  "network.ethernet_ports.status.down": "Inaktiv",
  "network.ethernet_ports.status.up": "Aktiv",
  "network.scan.error": "Netzwerkscan fehlgeschlagen",
  "network.summary.address": "IP-Adresse",
  "network.summary.dhcp_host_exists": "Adresse auf DHCP festgesetzt. Klicken Sie, um die Festsetzung aufzuheben.",
  "network.summary.error": "Fehler beim Laden",
  "network.summary.heat_pump": "Wärmepumpe",
  "network.summary.inverter": "Wechselrichter",
  "network.summary.mac": "MAC",
  "network.summary.name": "Name",
  "network.summary.no_dhcp_host": "Dynamische Adresse auf DHCP. Klicken Sie, um festzusetzen.",
  "network.summary.not_connected": "Nicht verbunden",
  "network.title": "Allgemein",
  "network.wan_address": "WAN-Adresse",
  "network_wan_edit.dialog.address": "IP-Adresse",
  "network_wan_edit.dialog.close": "Schließen",
  "network_wan_edit.dialog.dns": "DNS-Server",
  "network_wan_edit.dialog.gateway": "Standardgateway",
  "network_wan_edit.dialog.netmask": "Netzmaske",
  "network_wan_edit.dialog.save": "Speichern",
  "network_wan_edit.dialog.title": "WAN-Adresse bearbeiten",
  "nmap.empty": "Nichts gefunden",
  "nmap.error": "Scan fehlgeschlagen",
  "nmap.host": "Adresse",
  "nmap.loading": "Scannen",
  "nmap.output": "Ausgabe",
  "nmap.port": "Port",
  "nmap.port.help": "Leer = nur Gerätesuche",
  "nmap.range.external": "extern — Kundennetzwerk",
  "nmap.range.internal": "intern — Infigy-Netzwerk",
  "nmap.result.address": "IP-Adresse",
  "nmap.result.mac": "MAC-Adresse",
  "nmap.result.ports": "Ports",
  "nmap.result.scanning": "Scannen von {target}, dies kann eine Weile dauern…",
  "nmap.result.target": "Gescannter Bereich: {target}",
  "nmap.result.vendor": "Hersteller",
  "nmap.start": "Start",
  "nmap.target": "Adresse oder Bereich",
  "nmap.target.help": "Benanntes Netzwerk oder IP / Bereich",
  "nmap.title": "Portscan",
  "photovoltaics.battery": "Batterie",
  "photovoltaics.battery.battery_charged": "Laden der Batterie",
  "photovoltaics.battery.battery_manual_discharge": "Batterie manuell entladen",
  "photovoltaics.battery.battery_power": "Batterieleistung",
  "photovoltaics.battery.soc_actual": "Berechneter Mindestladestand",
  "photovoltaics.batteryStatus": "BMS-Status",
  "photovoltaics.battery_stop": "Batteriesperre",
  "photovoltaics.battery_stop.hdo": "Batterie nur bei Niedertarif (HDO) entladen",
  "photovoltaics.battery_stop.hp": "Batterie beim Betrieb der Wärmepumpe sperren",
  "photovoltaics.battery_stop.hw": "Batterie beim Betrieb der Warmwasserbereitung sperren",
  "photovoltaics.battery_stop.wb": "Batterie beim Betrieb der Wallbox sperren",
  "photovoltaics.battery_stop.wb.lock_desc": "Wenn der Wallbox-Lademodus „Laden gemäß Batterie“ aktiviert ist, kann diese Sperre nicht aktiviert werden. Stellen Sie einen anderen Wallbox-Lademodus ein, um die Sperre zu aktivieren.",
  "photovoltaics.battery_stop.wb.lock_title": "Einstellung kann nicht geändert werden",
  "photovoltaics.common": "Allgemeine Informationen",
  "photovoltaics.common.battery_charged": "Batterieladen",
  "photovoltaics.common.battery_manual_charge": "Batterie manuell laden",
  "photovoltaics.common.battery_manual_charge_soc": "Ziel-SOC für manuelles Laden",
  "photovoltaics.common.battery_manual_charge_subtitle": "Das manuelle Laden der Batterie lädt die Batterie auf den Zielladestand, sofern es nicht zuvor vom Benutzer ausgeschaltet wird.",
  "photovoltaics.common.battery_manual_discharge": "Batterie manuell entladen",
  "photovoltaics.common.battery_manual_discharge_subtitle": "Das manuelle Entladen der Batterie entlädt die Batterie auf den Mindestladestand, sofern es nicht zuvor vom Benutzer ausgeschaltet wird.",
  "photovoltaics.common.battery_power": "Batterieleistung",
  "photovoltaics.common.power": "Aktuelle Leistung",
  "photovoltaics.common.power_today": "Heutige Erzeugung:",
  "photovoltaics.common.power_total": "Gesamterzeugung",
  "photovoltaics.common.power_year": "Jahreserzeugung:",
  "photovoltaics.common.string1": "String 1:",
  "photovoltaics.common.string2": "String 2:",
  "photovoltaics.common.string3": "String 3:",
  "photovoltaics.common.string4": "String 4:",
  "photovoltaics.common.string5": "String 5:",
  "photovoltaics.common.string6": "String 6:",
  "photovoltaics.statistics": "Statistik",
  "photovoltaics.statistics.charge": "Laden der Batterie",
  "photovoltaics.statistics.discharge": "Entladen der Batterie",
  "photovoltaics.statisticsSoc": "Batteriestand",
  "photovoltaics.status": "Photovoltaikmodus",
  "ping.address": "Adresse",
  "ping.output": "Ausgabe",
  "ping.start": "Start",
  "ping.stop": "Stopp",
  "ping.title": "Ping",
  "plug.bat": "Steuerung nach Batterie",
  "plug.bat.batterySart": "Einschalten beim Laden",
  "plug.bat.batterySart.help": "Batteriestand, bei dem sich die Steckdose einschaltet. Damit sich die Steckdose einschaltet, muss der Batteriestand vom eingestellten Zustand in einen höheren Zustand wechseln. Ist der Wert auf 80 % gesetzt, schaltet sich die Steckdose ein, wenn die Batterie von 80 % auf 81 % geladen wird.",
  "plug.bat.batterySart.subtitle": "Batterieladung, bei der sich die Steckdose aktiviert",
  "plug.bat.batteryStop": "Ausschalten bei Ladezustand",
  "plug.bat.batteryStop.help": "Batteriestand, bei dem sich die Steckdose ausschaltet. Damit sich die Steckdose ausschaltet, muss der Batteriestand vom eingestellten Zustand in einen niedrigeren Zustand wechseln. Ist der Wert auf 80 % gesetzt, schaltet sich die Steckdose aus, wenn die Batterie von 80 % auf 79 % entladen wird.",
  "plug.bat.batteryStop.subtitle": "Batterieladung, bei der sich die Steckdose ausschaltet",
  "plug.bat.help": "Einschalten bei einem festgelegten Batteriestand. Kann mit einer Zeitbedingung kombiniert werden. Ist eine der Bedingungen zum Einschalten erfüllt, schaltet sich die Steckdose ein; ist eine der Bedingungen zum Ausschalten erfüllt, schaltet sich die Steckdose aus.",
  "plug.bat.on": "Aktiv",
  "plug.main": "Allgemeine Informationen",
  "plug.main.consumption": "Aktueller Verbrauch",
  "plug.main.power": "Gesamtverbrauch",
  "plug.main.power_today": "Heutiger Verbrauch:",
  "plug.main.power_year": "Jahresverbrauch:",
  "plug.main.stat": "Statistik",
  "plug.overflow": "Steuerung nach Überschuss",
  "plug.overflow.consumption": "Die Einstellung entspricht einem Gerät mit Leistungsaufnahme",
  "plug.overflow.help": "Einschalten der Steckdose bei einem festgelegten Überschuss ins Verteilnetz. Kann mit einer Zeitbedingung kombiniert werden. Ist eine der Bedingungen zum Einschalten erfüllt, schaltet sich die Steckdose ein; ist eine der Bedingungen zum Ausschalten erfüllt, schaltet sich die Steckdose aus.",
  "plug.overflow.on": "Aktiv",
  "plug.overflow.startPower": "Einschalten bei Netzbezug",
  "plug.overflow.startPower.help": "Die Steckdose schaltet sich ein, wenn der Überschuss nach einer festgelegten Verzögerung das eingestellte Niveau erreicht. Ist der Wert auf - 1500W gesetzt und die Einschaltverzögerung beträgt 5 Minuten, schaltet sich die Steckdose ein, wenn der Überschuss ins Netz mindestens 1500W für 5 Minuten beträgt.",
  "plug.overflow.startPower.subtitle": "Negativer Wert bedeutet Überschuss",
  "plug.overflow.stopPower": "Ausschalten bei Netzbezug",
  "plug.overflow.stopPower.help": "Die Steckdose schaltet sich aus, wenn der Verbrauch nach einer festgelegten Verzögerung über dem eingestellten Niveau liegt. Ist der Wert auf 100W gesetzt und die Ausschaltverzögerung beträgt 5 Minuten, schaltet sich die Steckdose aus, wenn der Verbrauch aus dem Netz mindestens 100W für 5 Minuten beträgt.",
  "plug.overflow.stopPower.subtitle": "Negativer Wert bedeutet Überschuss, positiver Wert bedeutet Verbrauch",
  "plug.overflow.time": "Ein- und Ausschaltverzögerung",
  "plug.overflow.time.help": "Dieser Parameter dient zur Festlegung der Verzögerung beim Ein- und Ausschalten der Steckdose bei definierten Überschüssen/Verbräuchen. Geeignet zur Prioritätseinstellung und zur Vermeidung häufigen Schaltens der Steckdose. Geben Sie das Format HH:MM ein.",
  "plug.plug": "Steckdose",
  "plug.spot": "Steuerung nach Spotpreis",
  "plug.spot.15m.period": "Spotpreisperiode",
  "plug.spot.15m.period.subtitle": "15-Minuten-Intervalle",
  "plug.spot.help": "Einschalten bei einem festgelegten Spotpreis. Kann mit einer Zeitbedingung kombiniert werden. Ist eine der Bedingungen zum Einschalten erfüllt, schaltet sich die Steckdose ein; ist eine der Bedingungen zum Ausschalten erfüllt, schaltet sich die Steckdose aus.",
  "plug.spot.on": "Aktiv",
  "plug.spot.period": "Spotpreisperiode",
  "plug.spot.period.subtitle": "60-Minuten-Intervalle",
  "plug.spot.price.period": "Zeitauflösung der Steckdose",
  "plug.spot.spotHi": "Bei hohem Preis aktivieren",
  "plug.spot.spotHi.help": "Die Steckdose schaltet sich ein, wenn der Spotpreis auf dem hohen Niveau liegt (siehe Registerkarte Spot).",
  "plug.spot.spotLow": "Bei niedrigem Preis aktivieren",
  "plug.spot.spotLow.help": "Die Steckdose schaltet sich ein, wenn der Spotpreis auf dem niedrigen Niveau liegt (siehe Registerkarte Spot).",
  "plug.spot.spotMi": "Bei mittlerem Preis aktivieren",
  "plug.spot.spotMi.help": "Die Steckdose schaltet sich ein, wenn der Spotpreis auf dem mittleren Niveau liegt (siehe Registerkarte Spot).",
  "plug.spot.spot_above_price": "Bei einem höheren als dem festgelegten Preis aktivieren",
  "plug.spot.spot_above_price.help": "Die Steckdose schaltet sich ein, wenn der Spotpreis höher oder gleich dem festgelegten Spotpreis ist.",
  "plug.spot.spot_above_price.subtitle": "Die Steckdose schaltet sich ein, wenn der Spotpreis höher oder gleich dem festgelegten Spotpreis ist. Ist er niedriger, schaltet sich die Steckdose aus.",
  "plug.spot.spot_below_price": "Bei einem niedrigeren als dem festgelegten Preis aktivieren",
  "plug.spot.spot_below_price.help": "Die Steckdose schaltet sich ein, wenn der Spotpreis niedriger oder gleich dem festgelegten Spotpreis ist.",
  "plug.spot.spot_below_price.subtitle": "Die Steckdose schaltet sich ein, wenn der Spotpreis niedriger oder gleich dem festgelegten Spotpreis ist. Ist er höher, schaltet sich die Steckdose aus.",
  "plug.spot.spot_neg": "Bei negativem Preis aktivieren",
  "plug.spot.spot_neg.help": "Die Steckdose schaltet sich ein, wenn der Spotpreis negativ ist (siehe Registerkarte Spot).",
  "plug.status": "Steckdosenmodus",
  "plug.summary.price": "Preis",
  "plug.summary.price_level": "Preisniveau",
  "plug.summary.price_level_15m": "Preisniveau 15 Min.",
  "plug.summary.switch": "Steckdosenschalter",
  "plug.summary.time": "Zeit",
  "plug.time": "Steuerung nach Zeit",
  "plug.time.help": "Einschalten zu einer festgelegten Zeit. Kann mit weiteren Bedingungen kombiniert werden, abhängig von der Batterie (muss installiert sein), dem Spotpreis (Spothandel muss erlaubt sein) und dem Überschuss (Überschuss ins Netz muss erlaubt sein). Ist eine der Bedingungen zum Einschalten erfüllt, schaltet sich die Steckdose ein; ist eine der Bedingungen zum Ausschalten erfüllt, schaltet sich die Steckdose aus.",
  "plug.time.on": "Aktiv",
  "plug.time.turn_off": "Zu einer festgelegten Zeit ausschalten",
  "plug.time.turn_off.help": "Zeit, zu der sich die Steckdose ausschaltet. Bei Einstellung auf 12:00 schaltet sich die Steckdose genau um 12:00 aus.",
  "plug.time.turn_on": "Zu einer festgelegten Zeit einschalten",
  "plug.time.turn_on.help": "Zeit, zu der sich die Steckdose einschaltet. Bei Einstellung auf 12:00 schaltet sich die Steckdose genau um 12:00 ein.",
  "plug.turn_off": "Ausschalten",
  "plug.turn_on": "Einschalten",
  "pre_flexibility.business_flexibility.title": "Kommerzielle Flexibilität",
  "pre_flexibility.enabled": "Integration aktiviert",
  "pre_flexibility.title": "PRE Flexibilität",
  "premium.banner.active.button": "Abonnement verwalten",
  "premium.banner.active.dev_mode": "Abonnement ist für die Entwicklung aktiv",
  "premium.banner.active.subtitle": "Das Infigy-Plus-Abonnement ist aktiv. Sie können alle zusätzlichen Funktionen der Anwendung nutzen.",
  "premium.banner.active.title": "Abonnement ist aktiv",
  "premium.banner.hide.confirm": "Möchten Sie das Infigy-Plus-Banner wirklich ausblenden?",
  "premium.banner.hide.confirm.description": "Sie können Infigy Plus jederzeit wieder in den Anwendungseinstellungen anzeigen.",
  "premium.banner.hide.later": "Später erinnern",
  "premium.banner.hide.show_more": "Mehr erfahren",
  "premium.banner.hide.yes": "Ausblenden",
  "premium.banner.inactive.button": "Mehr erfahren",
  "premium.banner.inactive.subtitle": "Heben Sie Ihr Energiemanagement auf die nächste Stufe. Mit Infigy Plus erhalten Sie noch mehr intelligente Werkzeuge – detaillierte Diagramme, sofortige Benachrichtigungen, einen erweiterten Kalender, detaillierte Berichte und mehr.",
  "premium.banner.inactive.title": "Infigy Plus ist nicht aktiv",
  "premium.dialog.charts.subtitle": "Verfolgen Sie die Leistung einzelner Strings, den Verbrauch nach Phasen und weitere detaillierte Informationen.",
  "premium.dialog.charts.title": "Detaillierte Diagramme",
  "premium.dialog.close": "Schließen",
  "premium.dialog.next.subtitle": "Wir bereiten viele zusätzliche Vorteile vor, die wir schrittweise für Infigy-Plus-Abonnenten freischalten",
  "premium.dialog.next.title": "Weitere Vorteile folgen in Kürze",
  "premium.dialog.notifications.subtitle": "Erhalten Sie Benachrichtigungen zu negativen Preisen, geladener Batterie und weiteren Ereignissen",
  "premium.dialog.notifications.title": "Benachrichtigungen",
  "premium.dialog.other_benefits.subtitle": "Wir bereiten zahlreiche zusätzliche Vorteile vor, die wir nach und nach für Infigy-Plus-Abonnenten bereitstellen",
  "premium.dialog.other_benefits.title": "Weitere Vorteile folgen in Kürze",
  "premium.dialog.reports.subtitle": "Detaillierte monatliche Berichte, die Ihnen ein klares Bild von Erzeugung, Verbrauch und Energienutzung in Ihrem Haushalt geben. Alle wichtigen Daten sind an einem Ort – übersichtlich und durch Diagramme ergänzt.",
  "premium.dialog.reports.title": "Erweiterte Berichte",
  "premium.dialog.save": "Infigy Plus abonnieren",
  "premium.dialog.schedule.subtitle": "Planen Sie das Laden oder Entladen der Batterie manuell nach Bedarf",
  "premium.dialog.schedule.title": "Erweiterter Kalender",
  "premium.dialog.spot.subtitle": "Sehen Sie die Historie der Spotpreise und der Pläne ein, die Infigy in der Vergangenheit erstellt hat",
  "premium.dialog.spot.title": "Historie der Spotpreise",
  "protocol.settings": "Einstellungen",
  "protocol.settings.Licence": "Lizenz",
  "protocol.settings.distribution": "Lizenz",
  "protocol.test": "Gerätetest",
  "protocol.test.internet-connect": "Internetverbindung",
  "protocol.test.inverter-connect": "Verbindung des Wechselrichters",
  "protocol.test.phase_1": "Test Phase 1",
  "protocol.test.phase_2": "Test Phase 2",
  "protocol.test.phase_3": "Test Phase 3",
  "protocol.test.tester": "Gerät getestet von",
  "relay.condition": "Einschaltbedingung",
  "relay.main": "Allgemeine Informationen",
  "relay.name": "Name des Relais",
  "relay.spot.diagram": "Steuerung nach Spotpreis",
  "relay.status": "Status",
  "relay.summary.switch": "Relaisschalter",
  "relay.title": "Relais",
  "report.avg_day_chart.battery_soc": "Ladezustand der Batterie",
  "report.avg_day_chart.consumption": "Verbrauch",
  "report.avg_day_chart.grid": "Netz",
  "report.avg_day_chart.pv_production": "PV-Erzeugung",
  "report.not_generated": "Bericht durch Klicken erstellen",
  "report_test.button": "Test",
  "report_test.date": "Monat (z. B. 2025-09)",
  "report_test.generated": "Bericht erstellt",
  "report_test.ok": "OK",
  "report_test.test": "Test",
  "reports.accumulation_increased": "Speicherung erhöht",
  "reports.average_water_temperature": "Durchschnittliche Wassertemperatur",
  "reports.avg_day": "Durchschnittlicher Tag",
  "reports.battery": "Batterie",
  "reports.boiler": "Elektroboiler",
  "reports.building_consumption": "Gebäudeverbrauch",
  "reports.disclaimer": "Die Werte haben nur informativen Charakter und können von den offiziellen Ablesungen des Netzbetreibers abweichen.",
  "reports.energy_estimate": "Energieschätzung ohne Steuerung",
  "reports.estimated_water_amount": "Geschätzte Wassermenge",
  "reports.grid_consumption": "Netzverbrauch",
  "reports.grid_consumption_hp": "Netzverbrauch für Wärmepumpe",
  "reports.grid_consumption_hw": "Netzverbrauch für Elektroboiler",
  "reports.grid_consumption_wallbox": "Netzverbrauch für Wallbox",
  "reports.heat_pump": "Wärmepumpe",
  "reports.household_consumption": "Haushaltsverbrauch",
  "reports.info": "Allgemeine Informationen",
  "reports.kilometers_driven": "Anzahl der gefahrenen Kilometer",
  "reports.kilometers_driven_from_sun": "Anzahl der mit Sonnenenergie gefahrenen Kilometer",
  "reports.maximum_power": "Maximale Leistung",
  "reports.monthly_consumption": "Monatlicher Verbrauch",
  "reports.monthly_production": "Monatliche Erzeugung",
  "reports.pv": "Photovoltaikanlage",
  "reports.pv_consumption": "PV-Verbrauch",
  "reports.pv_production": "PV-Erzeugung",
  "reports.regenerate_report": "Bericht neu erstellen",
  "reports.regenerate_report_confirm_title": "Bericht neu erstellen?",
  "reports.rfid_cards": "RFID-Karten",
  "reports.self_consumption": "Eigenverbrauch",
  "reports.self_sufficiency": "Autarkie",
  "reports.self_sufficient_days": "Anzahl der autarken Tage",
  "reports.share.description": "Sie können den ausgewählten Screenshot mit anderen teilen.",
  "reports.share.share": "Bericht teilen",
  "reports.share.title": "Bericht teilen",
  "reports.share_report": "Bericht teilen",
  "reports.sold_to_distribution_grid": "Ins Netz verkauft",
  "reports.stored_energy_from_grid": "Gespeicherte Energie aus dem Netz",
  "reports.stored_energy_from_pv": "Gespeicherte Energie aus PV",
  "reports.stored_energy_to_battery": "In der Batterie gespeicherte Energie",
  "reports.stored_energy_to_boiler": "Im Elektroboiler gespeicherte Energie",
  "reports.stored_energy_to_heat_pump": "In der Wärmepumpe gespeicherte Energie",
  "reports.stored_energy_to_wallbox": "In der Wallbox gespeicherte Energie",
  "reports.total_overflow_to_grid": "Gesamter Überschuss ins Netz",
  "reports.total_purchase_from_grid": "Gesamter Bezug aus dem Netz",
  "reports.total_with_control": "Gesamt mit Steuerung",
  "reports.total_without_control": "Gesamt ohne Steuerung",
  "reports.updated_at": "Erstellt {date}",
  "reports.wallbox": "Ladestation für Elektrofahrzeuge (Wallbox)",
  "rfid_cards.col.consumption": "Verbrauch",
  "rfid_cards.col.created_at": "Hinzugefügt",
  "rfid_cards.col.id": "Karten-ID",
  "rfid_cards.col.name": "Name",
  "rfid_cards.export": "CSV exportieren",
  "rfid_cards.from": "Von",
  "rfid_cards.no_cards": "Keine Karten hinzugefügt",
  "rfid_cards.title": "RFID-Karten",
  "rfid_cards.to": "Bis",
  "save": "Speichern",
  "schedules.add": "Zeitplan hinzufügen",
  "schedules.add.tooltip": "Hinzufügen",
  "schedules.battery_charge": "Laden der Batterie",
  "schedules.battery_discharge": "Entladen der Batterie",
  "schedules.charging_current": "Ladestrom: {chargingCurrent} A",
  "schedules.description": "Planen Sie das Laden oder Entladen der Batterie manuell nach Bedarf.",
  "schedules.dialog.title": "Planer",
  "schedules.dialog.title.ev": "Ladeplan erstellen",
  "schedules.ev_charging": "Laden des Elektrofahrzeugs",
  "schedules.form.action": "Aktion",
  "schedules.form.battery_charge": "Batterie laden",
  "schedules.form.battery_discharge": "Batterie entladen",
  "schedules.form.charging-current": "Ladestrom einstellen",
  "schedules.form.charging-current.auto": "Standard",
  "schedules.form.close": "Schließen",
  "schedules.form.create": "Erstellen",
  "schedules.form.duration": "Dauer (Minuten)",
  "schedules.form.duration.120min": "2 Stunden",
  "schedules.form.duration.180min": "3 Stunden",
  "schedules.form.duration.240min": "4 Stunden",
  "schedules.form.duration.300min": "5 Stunden",
  "schedules.form.duration.360min": "6 Stunden",
  "schedules.form.duration.60min": "1 Stunde",
  "schedules.form.ev_charging": "Laden des Elektrofahrzeugs",
  "schedules.form.frequency": "Häufigkeit",
  "schedules.form.frequency.daily": "Täglich",
  "schedules.form.frequency.monthly": "Monatlich",
  "schedules.form.frequency.weekly": "Wöchentlich",
  "schedules.form.interval.biweekly": "Alle 2 Wochen",
  "schedules.form.preview.hide": "Vorschau ausblenden",
  "schedules.form.preview.show": "Geplante Termine anzeigen",
  "schedules.form.preview.title": "Geplante Starts ({count} folgende)",
  "schedules.form.recurring": "Wiederkehrend",
  "schedules.form.target-soc": "Ziel-SOC (optional)",
  "schedules.form.until": "Wiederholen bis (optional)",
  "schedules.form.when": "Wann",
  "schedules.loading.error": "Fehler beim Laden der Zeitpläne",
  "schedules.missed": "Verpasst",
  "schedules.no_plans_found": "Keine Pläne gefunden.",
  "schedules.processed": "Verarbeitet",
  "schedules.remove.confirm": "Möchten Sie den Plan wirklich löschen?",
  "schedules.remove.no": "Abbrechen",
  "schedules.remove.recurring.instance": "Nur dieses Vorkommen löschen",
  "schedules.remove.recurring.series": "Gesamte Serie löschen",
  "schedules.remove.recurring.title": "Wiederkehrenden Plan löschen",
  "schedules.remove.yes": "Löschen",
  "schedules.running": "Läuft",
  "schedules.scheduled": "Geplant",
  "schedules.show_processed": "Verarbeitete anzeigen",
  "schedules.target_soc": "Ziel-SOC: {targetSoc, number, percent}",
  "schedules.title": "Planer",
  "scripts.add": "Erstellen",
  "scripts.delete": "Löschen",
  "scripts.edit": "Bearbeiten",
  "scripts.loading_error": "Fehler beim Laden der Skripte",
  "scripts.title": "Skripte",
  "settings.PV.NominalInverterPower": "Nennleistung des Wechselrichters",
  "settings.PV.NominalInverterPower.help": "Dies ist wichtig für die korrekte %-Berechnung der Überschüsse bei Solinteg, Wattsonic und Deye.",
  "settings.PV.NominalInverterPower.subtitle": "Nennleistung des Wechselrichters in kW, wichtig für die %-Berechnung der Überschüsse ins Netz.",
  "settings.PV.StringNumber": "Anzahl der Wechselrichter-Strings",
  "settings.PV.StringNumber.subtitle": "Anzahl der Wechselrichter-Strings, die im PV-Tab der Anwendung angezeigt werden",
  "settings.app_update": "Anwendungsversion",
  "settings.app_update.check_button": "Nach Updates suchen",
  "settings.app_update.confirm.cancel": "Abbrechen",
  "settings.app_update.confirm.confirm": "Aktualisieren",
  "settings.app_update.confirm.description": "Die Aktualisierung kann einige Minuten dauern. Während der Aktualisierung ist die Anwendung nicht verfügbar und startet anschließend automatisch neu.",
  "settings.app_update.confirm.title": "Aktualisierung starten?",
  "settings.app_update.error.no_internet": "Prüfen Sie Ihre Internetverbindung",
  "settings.app_update.in_progress": "Aktualisierung läuft",
  "settings.app_update.request_button": "Aktualisierung verfügbar",
  "settings.app_update.requested": "Aktualisierung wurde angefordert",
  "settings.app_update.subtitle": "Nach neuen Versionen suchen",
  "settings.app_update.title": "Aktualisierung der Anwendung",
  "settings.app_update.up_to_date": "Die Anwendung ist aktuell",
  "settings.boiler": "Elektroboiler",
  "settings.boiler.3phase": "Dreiphasiger Elektroboiler",
  "settings.boiler.3phase.subtitle": "Schließen Sie einen einphasigen Elektroboiler an den SSR-Ausgang der gewählten Phase an.",
  "settings.boiler.HwBatteryPriority": "Prozentsatz der Batterieladung, ab dem der Boiler zu heizen beginnt",
  "settings.boiler.HwBatteryPriority.help": "Wenn der Batterieladezustand niedriger als dieser Wert ist, steht die Priorität der Energiespeicherung vollständig der Batterie zur Verfügung. Ist der Batterieladezustand höher, übernimmt der Boiler die Priorität und beginnt, Wasser aus der überschüssigen PV-Energie zu erwärmen – ein Teil der Energie fließt weiter in die Batterie, bis diese geladen ist.",
  "settings.boiler.capacity": "Boilervolumen",
  "settings.boiler.capacity_sub": "Nur für den Spothandel erforderlich",
  "settings.boiler.enabled": "Elektroboiler installiert",
  "settings.boiler.hysterezis": "Boilerhysterese",
  "settings.boiler.hysterezis.subtitle": "Die Hysterese gilt nur für das reguläre Heizen",
  "settings.boiler.nominal": "Nennleistung",
  "settings.boiler.nominal.subtitle": "Nennaufnahme für 1 Phase des Elektroboilers",
  "settings.boiler.phase": "Boilerphase",
  "settings.boiler.phase.subtitle": "L1 = SSR-Ausgang 1, L2 = SSR-Ausgang 2, L3 = SSR-Ausgang 3.",
  "settings.boiler.prio": "Batteriepriorität",
  "settings.boiler.prio.subtitle": "Wenn Ein, wird zuerst die Batterie geladen, anschließend der Boiler",
  "settings.boiler.shellies": "Der Boiler wird über Shelly gesteuert",
  "settings.boiler.temp_enabled": "Temperatursensor installiert",
  "settings.boiler.temp_enabled.subtitle": "Ohne Sensor kann der Boiler nur für Überschüsse genutzt werden",
  "settings.device": "Gerät",
  "settings.device.SN": "Seriennummer",
  "settings.device.id": "Geräte-ID",
  "settings.device.license": "Gerätelizenz",
  "settings.docs": "Anleitungen und weitere Materialien",
  "settings.docs.service_settings_inverter.button": "Zur Wiki",
  "settings.docs.service_settings_inverter.subtitle": "Dokumentation, Verfahren und weitere Informationen",
  "settings.docs.service_settings_inverter.title": "Anleitung zum Anschluss des Wechselrichters",
  "settings.docs.tech_wiki.button": "Zur Wiki",
  "settings.docs.tech_wiki.subtitle": "Anleitungen, Verfahren und weitere Informationen",
  "settings.docs.tech_wiki.title": "Technische Wiki",
  "settings.docs.user_wiki.button": "Zur Wiki",
  "settings.docs.user_wiki.subtitle": "Anleitungen, Verfahren und weitere Informationen",
  "settings.docs.user_wiki.title": "Benutzer-Wiki",
  "settings.hdo": "Einstellung der Rundsteuerung (HDO)",
  "settings.hdo.help": "Einstellung der HDO-Zeiten für die Berechnung der Strompreise im Hoch- und Niedertarif. Unten können Sie die Zeiten des Niedertarifs festlegen.",
  "settings.hdo.on1": "Zeit 1",
  "settings.hdo.on2": "Zeit 2",
  "settings.hdo.on3": "Zeit 3",
  "settings.hdo.on4": "Zeit 4",
  "settings.hdo.on5": "Zeit 5",
  "settings.hdo.on6": "Zeit 6",
  "settings.hdo.regular": "Regulärer Werktag",
  "settings.hdo.start": "Start",
  "settings.hdo.stop": "Stopp",
  "settings.hdo.type": "Zeiten festlegen für",
  "settings.hdo.weekend": "HDO-Zeiten am Wochenende",
  "settings.heatpump": "Installation",
  "settings.heatpump.HpBatteryPriority": "Prozentsatz des Batterieladezustands (SOC), ab dem die Leistung der Wärmepumpe erhöht wird",
  "settings.heatpump.HpBatteryPriority.help": "Wenn der Batterieladezustand niedriger als dieser Wert ist, steht die Priorität der Energiespeicherung vollständig der Batterie zur Verfügung. Ist der Batterieladezustand höher, übernimmt die Wärmepumpe die Priorität und beginnt, Wasser aus der überschüssigen PV-Energie zu erwärmen – ein Teil der Energie fließt weiter in die Batterie, bis diese geladen ist.",
  "settings.heatpump.enabled": "Wärmepumpe installiert",
  "settings.heatpump.flexiAN": "Flexibilität des Pufferspeichers",
  "settings.heatpump.flexiCool": "Kühlflexibilität",
  "settings.heatpump.flexiHw": "Warmwasserflexibilität",
  "settings.heatpump.flexiRoom": "Raumflexibilität",
  "settings.heatpump.hp_type": "Typ der Wärmepumpe",
  "settings.heatpump.nominal": "Nennaufnahmeleistung",
  "settings.heatpump.nominal1": "Nennaufnahmeleistung",
  "settings.heatpump.priority": "Die Wärmepumpe hat eine höhere Priorität als die Batterie",
  "settings.heatpump.priority-wb": "Die Wärmepumpe hat eine höhere Priorität als die Wallbox",
  "settings.heatwatter": "Boiler",
  "settings.heatwatter.legionella": "Legionella",
  "settings.heatwatter.legionella_temp": "Desinfektionstemperatur",
  "settings.heatwatter.legionella_temp.subtitle": "Temperatur, auf die der Boiler mindestens einmal alle 14 Tage aufgeheizt werden muss",
  "settings.inverter_communication_status": "Wechselrichterkommunikation",
  "settings.inverter_communication_status.not_ok": "Nicht verbunden,{br}Verbindungsversuch...",
  "settings.inverter_communication_status.ok": "Kommunikation hergestellt{br}({count} Ablesungen)",
  "settings.inverter_communication_status.subtitle": "Der Aufbau der Kommunikation kann einige zehn Sekunden bis mehrere Minuten dauern",
  "settings.notification": "Benachrichtigungen",
  "settings.notification.application_settings": "Benachrichtigungen – Parameter",
  "settings.notification.battery_max_soc": "Maximaler SOC der Batterie",
  "settings.notification.battery_max_soc.subtitle": "Eine Benachrichtigung wird erzeugt, wenn der maximale SOC der Batterie erreicht wird. Die Benachrichtigung wird nur einmal täglich erzeugt.",
  "settings.notification.battery_max_soc_value": "Maximaler SOC der Batterie für Benachrichtigungen",
  "settings.notification.battery_max_soc_value.subtitle": "Legen Sie den SOC der Batterie fest, bei dem eine Benachrichtigung erzeugt wird.",
  "settings.notification.battery_min_soc": "Minimaler SOC der Batterie",
  "settings.notification.battery_min_soc.subtitle": "Eine Benachrichtigung wird erzeugt, wenn der SOC der Batterie auf den festgelegten Mindestwert fällt. Die Benachrichtigung wird nur einmal täglich erzeugt.",
  "settings.notification.battery_min_soc_value": "Minimaler SOC der Batterie für Benachrichtigungen",
  "settings.notification.battery_min_soc_value.subtitle": "Legen Sie den SOC der Batterie fest, bei dem eine Benachrichtigung erzeugt wird.",
  "settings.notification.daily_prediction.subtitle": "Die Benachrichtigung wird jeden Tag um 8:00 erzeugt",
  "settings.notification.description": "Berechtigung zum Erzeugen von Benachrichtigungen, die in der Anwendung generiert werden",
  "settings.notification.heat_pump_limit_exceeded": "Überschreitung des Limits für den Wärmepumpenverbrauch",
  "settings.notification.heat_pump_limit_exceeded.subtitle": "Eine Benachrichtigung wird erzeugt, wenn das Limit für den Wärmepumpenverbrauch überschritten wird",
  "settings.notification.heat_pump_limit_value": "Tageslimit des Wärmepumpenverbrauchs für Benachrichtigungen",
  "settings.notification.heat_pump_limit_value.subtitle": "Legen Sie das Limit für den Wärmepumpenverbrauch fest, bei dem eine Benachrichtigung erzeugt wird.",
  "settings.notification.heat_water_limit_exceeded": "Überschreitung des Limits für die Warmwasserbereitung",
  "settings.notification.heat_water_limit_exceeded.subtitle": "Eine Benachrichtigung wird erzeugt, wenn das Limit für die Warmwasserbereitung überschritten wird",
  "settings.notification.heat_water_limit_value": "Tageslimit der Warmwasserbereitung für Benachrichtigungen",
  "settings.notification.heat_water_limit_value.subtitle": "Legen Sie das Limit für die Warmwasserbereitung fest, bei dem eine Benachrichtigung erzeugt wird.",
  "settings.notification.heat_water_max_temperature": "Die maximale Wassertemperatur wurde erreicht",
  "settings.notification.heat_water_max_temperature.subtitle": "Eine Benachrichtigung wird erzeugt, wenn die maximale Temperatur des Wassers im Boiler aus PV-Energie erreicht wird",
  "settings.notification.home_consumption_limit_exceeded": "Überschreitung des Limits für den Hausverbrauch",
  "settings.notification.home_consumption_limit_exceeded.subtitle": "Eine Benachrichtigung wird erzeugt, wenn das Limit für den Hausverbrauch überschritten wird",
  "settings.notification.home_consumption_limit_value": "Tageslimit des Hausverbrauchs für Benachrichtigungen",
  "settings.notification.home_consumption_limit_value.subtitle": "Legen Sie das Limit für den Hausverbrauch fest, bei dem eine Benachrichtigung erzeugt wird.",
  "settings.notification.iverter_disconnected": "Die Kommunikation mit dem Wechselrichter wurde unterbrochen",
  "settings.notification.iverter_disconnected.subtitle": "Eine Benachrichtigung wird zu Beginn und am Ende des Kommunikationsverlusts mit dem Wechselrichter erzeugt",
  "settings.notification.negative_spot": "Negativer Preis am Spot",
  "settings.notification.negative_spot.subtitle": "Eine Benachrichtigung wird zu Beginn und am Ende des negativen Preises am Spot erzeugt",
  "settings.notification.pv_production_mwh": "Meilenstein der PV-Erzeugung",
  "settings.notification.pv_production_mwh.subtitle": "Eine Benachrichtigung wird erzeugt, wenn die PV im jeweiligen Jahr MWh Energie erzeugt",
  "settings.notification.spot_charging_battery": "Start und Stopp des Batterieladens gemäß Spotpreis",
  "settings.notification.spot_charging_battery.subtitle": "Eine Benachrichtigung wird zu Beginn und am Ende des Batterieladens gemäß Spotpreis erzeugt",
  "settings.notification.spot_daily_prediction": "Tägliche Vorhersage",
  "settings.notification.spot_daily_summary": "Tägliche Zusammenfassung des Spotplans",
  "settings.notification.spot_daily_summary.subtitle": "Die Benachrichtigung wird jeden Tag um 8:00 erzeugt",
  "settings.notification.spot_discharging_battery": "Start und Stopp des Batterieentladens ins Netz gemäß Spotpreis",
  "settings.notification.spot_discharging_battery.subtitle": "Eine Benachrichtigung wird zu Beginn und am Ende des Batterieentladens ins Netz gemäß Spotpreis erzeugt",
  "settings.notification.utility_loss": "Netzausfall",
  "settings.notification.utility_loss.subtitle": "Eine Benachrichtigung wird zu Beginn und am Ende des Netzausfalls erzeugt",
  "settings.notification.wallbox_charging_start_stop": "Start und Stopp des Ladens des Elektrofahrzeugs",
  "settings.notification.wallbox_charging_start_stop.subtitle": "Eine Benachrichtigung wird zu Beginn und am Ende des Ladens des Elektrofahrzeugs erzeugt",
  "settings.notification.wallbox_limit_exceeded": "Überschreitung des Limits für das Laden des Elektrofahrzeugs",
  "settings.notification.wallbox_limit_exceeded.subtitle": "Eine Benachrichtigung wird erzeugt, wenn das Limit für das Laden des Elektrofahrzeugs überschritten wird",
  "settings.notification.wallbox_limit_value": "Tageslimit für das Laden des Elektrofahrzeugs für Benachrichtigungen",
  "settings.notification.wallbox_limit_value.subtitle": "Legen Sie das Limit für das Laden des Elektrofahrzeugs fest, bei dem eine Benachrichtigung erzeugt wird.",
  "settings.notification.webapp.subtitle": "Sie können Benachrichtigungen von Infigy über die Webanwendung erhalten.",
  "settings.notification.webapp.title": "Webanwendung",
  "settings.other": "Sonstiges",
  "settings.other.dark_mode": "Dunkelmodus",
  "settings.other.languate": "Sprache",
  "settings.other.overflow_fronius": "Der maximale Überschuss ins Netz wird auf Seiten des Fronius-Wechselrichters begrenzt",
  "settings.other.overflow_fronius_subtitle": "Dieser Wert wird vom Netzbetreiber festgelegt. Eine Überschreitung kann zu finanziellen Strafen durch den Netzbetreiber führen.",
  "settings.other.overflow_settings": "Überschusswert festlegen",
  "settings.other.overflow_settings.help": "Dies ist ein serviceseitig festgelegter Wert des maximalen Überschusses. Dieser Wert wird vom Netzbetreiber festgelegt. Eine Überschreitung kann zu finanziellen Strafen durch den Netzbetreiber führen.",
  "settings.other.readability_mode": "Schriftgröße",
  "settings.photovoltaics": "Photovoltaik",
  "settings.photovoltaics.backup_enabled": "Backup aktiviert",
  "settings.photovoltaics.backup_enabled.subtitle": "Informationen zum Backup-Modus des Wechselrichters.",
  "settings.photovoltaics.batterychargingpower": "Ladeleistung der Batterie",
  "settings.photovoltaics.batterychargingpower_sub": "Leistung für manuelles Batterieladen und Spotladen aus dem Netz",
  "settings.photovoltaics.batterydischargingpower": "Entladeleistung der Batterie",
  "settings.photovoltaics.batterydischargingpower_sub": "Leistung für das Spotentladen der Batterie ins Netz",
  "settings.photovoltaics.batteryenabled": "Batterie installiert",
  "settings.photovoltaics.batterynominal": "Nennkapazität der Batterie",
  "settings.photovoltaics.batterynominal_sub": "Nur für den Spothandel erforderlich",
  "settings.photovoltaics.enabled": "Photovoltaik installiert",
  "settings.photovoltaics.gridchargeenabled": "Laden der Batterie aus dem Verteilnetz erlaubt",
  "settings.photovoltaics.inverters-adjust-power": "Aktuelle Wechselrichterleistung",
  "settings.photovoltaics.inverters-nominal": "Nennleistung der regelbaren Wechselrichter",
  "settings.photovoltaics.nominal": "Nennleistung",
  "settings.photovoltaics.overflow": "Unbegrenzter Netzüberschuss",
  "settings.photovoltaics.overflow.value": "Überschussbegrenzung",
  "settings.photovoltaics.overflow.value.help": "Wert des maximalen Überschusses ins Netz. Dieser Wert wird in den Wechselrichter geschrieben. Ändern Sie diesen Wert nicht im Wechselrichter. Die Überschussbegrenzung wird von Infigy gesteuert. Prüfen Sie den geschriebenen Wert im Wechselrichter.",
  "settings.photovoltaics.overflow_fronius.value.help": "Wert des maximalen Überschusses ins Netz auf Seiten des Fronius-Wechselrichters. Dient Infigy als Information für die korrekte Visualisierung der Überschüsse.",
  "settings.photovoltaics.settings": "Batterie",
  "settings.photovoltaics.settings.soc_actual": "Berechnete Mindestladung",
  "settings.photovoltaics.settings.soc_actual.help": "Dieser Wert wird automatisch anhand des aktuellen Zustands berechnet. Er wird entweder durch automatisches Laden gemäß der Jahreszeit oder durch manuelle Einstellung der Mindestladung mit und ohne Verteilnetz gesteuert. Bei einem Wert von 100 % ist das Entladen der Batterie untersagt, z. B. gemäß Spothandel.",
  "settings.photovoltaics.settings.soc_grid": "Mindestladung mit Verteilnetz",
  "settings.photovoltaics.settings.soc_grid.help": "Mit diesem Wert können Sie die Mindestladung der Batterie in % SOC steuern, wenn das Verteilnetz verfügbar ist. Bei Solax im Backup-Modus beträgt die Mindestladung der Batterie 15 %.",
  "settings.photovoltaics.settings.temp": "Minimale Ladung bei Netz",
  "settings.photovoltaics.settings.temp.help": "Mit diesem Wert können Sie die minimale Ladung der Batterie in % SOC steuern, wenn das Verteilnetz verfügbar ist.",
  "settings.photovoltaics.settings.temp_ek": "Mindestladung ohne Netz",
  "settings.photovoltaics.settings.temp_ek.help": "Mit diesem Wert können Sie die Mindestladung der Batterie in % SOC steuern, wenn das Verteilnetz nicht verfügbar ist.",
  "settings.photovoltaics.unbalanced_enabled": "Asymmetrie des Wechselrichters",
  "settings.photovoltaics.unbalanced_enabled.subtitle": "Informationen zur Asymmetrie des Wechselrichters.",
  "settings.photovoltaics_auto_settings": "Automatische Ladesteuerung",
  "settings.photovoltaics_auto_settings.subtitle": "Automatische Regelung des Mindest-SOC gemäß der Jahreszeit",
  "settings.plug": "Steckdosen",
  "settings.plug.Led": "Dauerhafte Hintergrundbeleuchtung",
  "settings.plug.Led-batt": "Hintergrundbeleuchtung bei geladener Batterie",
  "settings.plug.Led-batt.subtitle": "Hintergrundbeleuchtung aktiv, wenn die Batterie mindestens 95 % hat",
  "settings.plug.Led-over": "Hintergrundbeleuchtung bei Überschuss",
  "settings.plug.enabled": "Steckdosen installiert",
  "settings.plug.enabled.subtitle": "Steckdosen im lokalen Netzwerk",
  "settings.plug.enabled2": "Zweite Steckdose",
  "settings.plug.enabled3": "Dritte Steckdose",
  "settings.plug.ip1": "Die IP-Adresse der ersten Steckdose",
  "settings.plug.ip1.label": "IP 3",
  "settings.plug.ip2": "Die IP-Adresse der zweiten Steckdose",
  "settings.plug.ip2.label": "IP 2",
  "settings.plug.ip3": "Die IP-Adresse der dritten Steckdose",
  "settings.plug.ip3.label": "IP 3",
  "settings.plug.modulenabled": "Steckdosen am Modul",
  "settings.plug.modulip": "IP-Adresse des Moduls",
  "settings.plug.modulip.label": "IP-Modul",
  "settings.plug.name1": "Name der Steckdose 1",
  "settings.plug.name1.label": "Name",
  "settings.plug.name2": "Name der Steckdose 2",
  "settings.plug.name2_label": "Name",
  "settings.plug.name3": "Name der Steckdose 3",
  "settings.plug.name3.label": "Name",
  "settings.plug.statusLed": "Signallediode",
  "settings.readability_mode.default": "Standard",
  "settings.readability_mode.large": "Groß",
  "settings.relay": "Relais",
  "settings.relay.0.enabled": "Erstes Relais",
  "settings.relay.1.enabled": "Zweites Relais",
  "settings.relay.1.type": "Bedingung",
  "settings.relay.1.type.HDO": "HDO spiegeln",
  "settings.relay.1.type.batteryfull": "Batterie über 95 % geladen",
  "settings.relay.1.type.batterylow": "Batterie unter dem eingestellten Minimum geladen",
  "settings.relay.1.type.bojlerFull": "Boiler ist fast aufgeheizt",
  "settings.relay.1.type.none": "Nicht verwendet",
  "settings.relay.1.type.plug1": "Steckdose 1",
  "settings.relay.1.type.plug2": "Steckdose 2",
  "settings.relay.1.type.plug3": "Steckdose 3",
  "settings.relay.1.type.spotHi": "Hoher Spotpreis",
  "settings.relay.1.type.spotLow": "Niedriger Spotpreis",
  "settings.relay.1.type.spotMi": "Mittlerer Spotpreis",
  "settings.relay.1.type.spotNegative": "Negativer Spotpreis",
  "settings.relay.1.type.thermostat1": "Thermostatkreis 1",
  "settings.relay.1.type.thermostat2": "Thermostatkreis 2",
  "settings.relay.1.type.thermostat3": "Thermostatkreis 3",
  "settings.relay.1.type.thermostat4": "Thermostatkreis 4",
  "settings.relay.2.enabled": "Drittes Relais",
  "settings.relay.3.enabled": "Viertes Relais",
  "settings.relay.above_price_relay": "Spotpreis für die Aktivierung des Relais",
  "settings.relay.above_price_relay.subtitle": "Wenn der Spotpreis höher als dieser Wert ist, schaltet das Relais ein. Wenn er niedriger ist, schaltet das Relais aus.",
  "settings.relay.above_price_relay_15m": "Spotpreis für die Aktivierung des Relais (15 min)",
  "settings.relay.above_price_relay_15m.subtitle": "Wenn der Spotpreis höher als dieser Wert ist, schaltet das Relais ein. Wenn er niedriger ist, schaltet das Relais aus.",
  "settings.relay.above_soc_relay": "Batterieladung für die Aktivierung des Relais",
  "settings.relay.above_soc_relay.subtitle": "Wenn die Batterieladung höher als dieser Wert ist, schaltet das Relais ein.",
  "settings.relay.above_soc_relay_hyst": "Hysterese des Batterie-SOC für die Deaktivierung des Relais",
  "settings.relay.above_soc_relay_hyst.subtitle": "Wenn die Batterieladung um diesen Wert unter den eingestellten Aktivierungswert sinkt, schaltet das Relais aus.",
  "settings.relay.below_price_relay": "Spotpreis für die Aktivierung des Relais",
  "settings.relay.below_price_relay.subtitle": "Wenn der Spotpreis niedriger als dieser Wert ist, schaltet das Relais ein. Wenn er höher ist, schaltet das Relais aus.",
  "settings.relay.below_price_relay_15m": "Spotpreis für die Aktivierung des Relais (15 min)",
  "settings.relay.below_price_relay_15m.subtitle": "Wenn der Spotpreis niedriger als dieser Wert ist, schaltet das Relais ein. Wenn er höher ist, schaltet das Relais aus.",
  "settings.relay.below_soc_relay": "Batterieladung für die Aktivierung des Relais",
  "settings.relay.below_soc_relay.subtitle": "Wenn die Batterieladung um diesen Wert unter den eingestellten Aktivierungswert sinkt, schaltet das Relais aus.",
  "settings.relay.below_soc_relay_hyst": "Hysterese des Batterie-SOC für die Deaktivierung des Relais",
  "settings.relay.below_soc_relay_hyst.subtitle": "Wenn die Batterieladung um diesen Wert über den eingestellten Aktivierungswert steigt, schaltet das Relais aus.",
  "settings.relay.enabled": "Relais installiert",
  "settings.relay.enabled.subtitle": "Integrierte Relais",
  "settings.relay.item.enabled": "Relais {index}",
  "settings.relay.item.name": "Relaisname",
  "settings.relay.item.status": "Status",
  "settings.relay.option": "Bedingung",
  "settings.relay.temp_above_relay.subtitle": "Wenn die Boilertemperatur höher als dieser Wert ist, schaltet das Relais ein.",
  "settings.relay.temp_above_relay_hyst.subtitle": "Wenn die Boilertemperatur um diesen Wert unter den eingestellten Aktivierungswert sinkt, schaltet das Relais aus.",
  "settings.relay.temp_below_relay.subtitle": "Wenn die Boilertemperatur niedriger als dieser Wert ist, schaltet das Relais ein.",
  "settings.relay.temp_below_relay_hyst": "Hysterese der Boilertemperatur in °C für die Deaktivierung des Relais",
  "settings.relay.temp_below_relay_hyst.subtitle": "Wenn die Boilertemperatur um diesen Wert über den eingestellten Aktivierungswert steigt, schaltet das Relais aus.",
  "settings.relay.temp_relay": "Boilertemperatur für die Aktivierung des Relais",
  "settings.relay.temp_relay_hyst": "Hysterese der Boilertemperatur in °C für die Deaktivierung des Relais",
  "settings.relay.type.Active": "Dauerhaft ein",
  "settings.relay.type.HDO": "HDO spiegeln",
  "settings.relay.type.batteryBelowSOC": "Batterieladung unter dem eingestellten SOC",
  "settings.relay.type.batteryDischarge": "Entladen der Batterie ins Netz",
  "settings.relay.type.batteryFull": "Batterieladung über dem eingestellten SOC",
  "settings.relay.type.batteryLow": "Batterieladung unter dem eingestellten Minimum",
  "settings.relay.type.bojlerFull": "Boiler ist nahezu aufgeheizt",
  "settings.relay.type.hdo": "HDO spiegeln",
  "settings.relay.type.heatWaterAboveTemp": "Boiler ist über die eingestellte Temperatur aufgeheizt",
  "settings.relay.type.heatWaterBelowTemp": "Boiler ist unter die eingestellte Temperatur aufgeheizt",
  "settings.relay.type.heatWaterMaxTemp": "Boiler ist nahezu aufgeheizt",
  "settings.relay.type.heatWaterTemp": "Boiler ist über die eingestellte Temperatur aufgeheizt",
  "settings.relay.type.none": "Nicht verwendet, dauerhaft aus",
  "settings.relay.type.plug1": "Steckdose 1",
  "settings.relay.type.plug2": "Steckdose 2",
  "settings.relay.type.plug3": "Steckdose 3",
  "settings.relay.type.plug4": "Steckdose 4",
  "settings.relay.type.spotBatteryDischarge": "Entladen der Batterie ins Netz",
  "settings.relay.type.spotHi": "Hoher Spotpreis",
  "settings.relay.type.spotHi15M": "Hoher Spotpreis (15 min)",
  "settings.relay.type.spotLow": "Niedriger Spotpreis",
  "settings.relay.type.spotLow15M": "Niedriger Spotpreis (15 min)",
  "settings.relay.type.spotMi": "Mittlerer Spotpreis",
  "settings.relay.type.spotMi15M": "Mittlerer Spotpreis (15 min)",
  "settings.relay.type.spotNegative": "Begrenzung der Überschüsse ins Netz",
  "settings.relay.type.spotNegative15M": "Verbot von Überschüssen ins Stromnetz (15 min)",
  "settings.relay.type.spotPriceAbove": "Spotpreis über dem eingestellten Wert",
  "settings.relay.type.spotPriceAbove15M": "Spotpreis über dem eingestellten Wert (15 min)",
  "settings.relay.type.spotPriceBelow": "Spotpreis unter dem eingestellten Wert",
  "settings.relay.type.spotPriceBelow15M": "Spotpreis unter dem eingestellten Wert (15 min)",
  "settings.relay.type.spotStopAccumulation": "Speicherung gestoppt, aktiver Verkauf",
  "settings.relay.type.stopAccumulation": "Speicherung gestoppt, aktiver Verkauf",
  "settings.relay.type.thermostat1": "Thermostat 1",
  "settings.relay.type.thermostat2": "Thermostat 2",
  "settings.relay.type.thermostat3": "Thermostat 3",
  "settings.relay.type.thermostat4": "Thermostat 4",
  "settings.relay.user_advanced_control": "Seite mit Informationen für den Benutzer anzeigen",
  "settings.relay.user_advanced_control.subtitle": "Wenn aktiviert, erscheint eine Seite in der Navigation",
  "settings.service": "Service",
  "settings.service.connection_type": "Verbindung",
  "settings.service.customer": "Benutzername",
  "settings.service.customer-email": "E-Mail des Benutzers",
  "settings.service.customer-email-subtitle": "Wenn der Benutzer kein Konto unter dieser E-Mail hat, wird automatisch ein Konto erstellt und eine Registrierungs-E-Mail gesendet",
  "settings.service.customer-email.label": "E-Mail",
  "settings.service.customer-subtitle": "Dient zur Identifikation der Installation für das Unternehmen und den Kunden",
  "settings.service.customer.label": "Name",
  "settings.service.exit": "Vom Service abmelden",
  "settings.service.exit.button": "Abmelden",
  "settings.service.info": "Installation",
  "settings.service.inverter_type": "Wechselrichtertyp",
  "settings.service.inverter_type.label": "Wechselrichter",
  "settings.service.modbus_tcp": "LAN/WiFi",
  "settings.service.network": "Netzwerk",
  "settings.service.network.help.content": "Die Liste zeigt Geräte, die aktuell mit dem Infigy-Netzwerk verbunden sind (WiFi oder Kabel), ihre IP-Adressen, MAC-Adressen usw. Wenn ein Gerät DHCP verwendet, können Sie auf die Stecknadel klicken, um die IP-Adresse festzulegen, die der DHCP-Server dann immer vergibt – das ist nützlich für Geräte wie Wechselrichter, Wärmepumpen usw. Wenn ein Gerät eine statische IP-Adresse verwendet, wird es möglicherweise nicht korrekt angezeigt.",
  "settings.service.network.help.title": "Netzwerkeinstellungen",
  "settings.service.network.mac": "MAC-Adresse",
  "settings.service.network.online.internet": "Internetzugang",
  "settings.service.network.online.internet.help": "Ein Internetzugang ist für den Fernzugriff, Systemaktualisierungen, Spotpreise und weitere Funktionen erforderlich. Für die volle Funktionalität müssen alle drei Anzeigen grün sein.{br}{br}Die erste Anzeige zeigt die Verfügbarkeit des Internets (Ping 8.8.8.8).{br}{br}Die zweite Anzeige zeigt die Verfügbarkeit des Internets einschließlich DNS (Ping infigy.cz).{br}{br}Die dritte Anzeige zeigt den Zugriff auf die internen Cloud-Dienste von Infigy (VPN-Verfügbarkeit).{br}{br}Wenn es ein Problem mit der Verbindung gibt, prüfen Sie bitte das Kabel oder kontaktieren Sie den Netzwerkadministrator, falls das lokale Netzwerk Einschränkungen für die Kommunikation ins Internet hat.{br}{br}{wikiLink}",
  "settings.service.network.online.internet.help.wikiLink": "Weitere Informationen in unserem Wiki.",
  "settings.service.network.online.portal": "Zugang zum Infigy-Portal",
  "settings.service.network.wan": "WAN-Adresse",
  "settings.service.network.wifi_passphrase": "WLAN-Passwort",
  "settings.service.network_type": "Netzwerk",
  "settings.service.network_type.custom": "Manuelle Adresseinstellung",
  "settings.service.network_type.external": "Lokales Netzwerk (Kunde)",
  "settings.service.network_type.internal": "Internes Infigy-Netzwerk",
  "settings.service.password": "Zugang zum Service",
  "settings.service.password.label": "Passwort",
  "settings.service.relay": "Relais",
  "settings.service.reset": "Fehlerreset",
  "settings.service.reset.button": "Fehlerreset",
  "settings.service.rs485": "RS485",
  "settings.service.service-email": "E-Mail der Servicefirma",
  "settings.service.service-email-subtitle": "Um das Gerät mit dem Installationskonto zu verknüpfen, müssen Sie die E-Mail der Servicefirma eingeben, die im Partnerbereich der Anwendung hinterlegt ist",
  "settings.service.service-email.label": "E-Mail",
  "settings.service.servicer": "Name des Installateurs",
  "settings.service.servicer.label": "Name",
  "settings.service.solidsun_op": "SolidSun OP",
  "settings.service.solidsun_op.label": "SolidSun OP",
  "settings.service.spot": "Spot-Handel",
  "settings.service.tester.label": "Name des Testers",
  "settings.service.thermostat": "Thermostat",
  "settings.service.town": "Standort (Ort)",
  "settings.service.version": "Anwendungsversion",
  "settings.service.wallbox_type": "Wallbox-Typ",
  "settings.service.wallbox_type.label": "Wallbox",
  "settings.spot": "Spot-Handel",
  "settings.spot.battery": "Laden der Batterie gemäß Spot erlaubt",
  "settings.spot.battery.stop_discharge_auto": "Automatische Steuerung des Entladeverbots",
  "settings.spot.battery.stop_discharge_auto.help": "Wenn Sie diese Option wählen, steuert das System das Entladen der Batterie automatisch und erlaubt es nur zu den höchsten täglichen Spotpreisen.",
  "settings.spot.battery.stop_discharge_auto.subtitle": "Steuerung der Energiespeicherung automatisch zum höchsten Preis",
  "settings.spot.battery.stop_discharge_hi_price": "Entladen der Batterie bei niedrigen und mittleren Preisen verbieten",
  "settings.spot.battery.stop_discharge_high_price": "Entladen der Batterie bei niedrigem und mittlerem Preis verbieten",
  "settings.spot.battery.stop_discharge_high_price.help": "Wenn Sie diese Option wählen, nutzt das System bei niedrigem und mittlerem Spotpreis keine Energie aus der Batterie. Das System entlädt die Batterie nicht. Sie wird bei höheren Preisen genutzt.",
  "settings.spot.battery.stop_discharge_low_price": "Entladen der Batterie bei niedrigem Preis verbieten",
  "settings.spot.battery.stop_discharge_low_price.help": "Wenn Sie diese Option wählen, nutzt das System bei niedrigem Spotpreis keine Energie aus der Batterie. Das System entlädt die Batterie nicht. Sie wird bei höheren Preisen genutzt (mittlerer und hoher Preis).",
  "settings.spot.battery.stop_discharge_low_price.subtitle": "Steuerung der Energiespeicherung bei mittlerem und hohem Preis",
  "settings.spot.battery.stop_discharge_middle_price.subtitle": "Steuerung der Energiespeicherung bei hohem Preis",
  "settings.spot.batteryAllOverflowPrice": "Mindestpreis für das Entladen der gesamten Batteriekapazität",
  "settings.spot.batteryOverflow": "Entladen der Batterie ins Netz gemäß Spotpreisen erlauben",
  "settings.spot.batteryOverflowPrice": "Mindestpreis für das Entladen der Batterie",
  "settings.spot.batterySale": "Entladen der Batterie ins Netz gemäß Spotpreisen erlaubt",
  "settings.spot.battery_all_overflow_price": "Mindestpreis für das Entladen der gesamten Batteriekapazität",
  "settings.spot.battery_all_overflow_price.help": "Wenn der Spotpreis höher als dieser Wert ist, wird die Batteriekapazität bis zum eingestellten Mindest-SOC ins Netz entladen. Das bedeutet, dass die Energie nicht in der Batterie für den Nacht- und Morgenverbrauch gespeichert wird. Nach dem Entladen der Batterie ins Netz wird die Energie für den Verbrauch des Objekts aus dem Netz bezogen.",
  "settings.spot.battery_all_overflow_price.subtitle": "Die Energie wird in der Batterie für den Tagesverbrauch gespeichert",
  "settings.spot.battery_charge": "Laden der Batterie nach Spot zugelassen",
  "settings.spot.battery_charge.help": "Wenn Sie diese Option wählen, plant das System das Laden zu den niedrigsten Preisen. Es berücksichtigt den aktuellen Ladezustand der Batterie und ihre Kapazität. Anhand dieser Parameter wählt es die Ladedauer so, dass die Batterie zum niedrigstmöglichen Preis geladen wird.",
  "settings.spot.battery_charge.subtitle": "Die Steuerung der Batterie nach dem Spot erhöht die Abnutzung der Batterie",
  "settings.spot.battery_max_soc": "End-SOC der Batterie",
  "settings.spot.battery_max_soc.subtitle": "Maximale Ladung der Batterie beim Laden aus dem Netz",
  "settings.spot.battery_overflow": "Entladen der Batterie ins Netz nach Spotpreisen zulassen",
  "settings.spot.battery_overflow.help": "Wenn Sie diese Option wählen, plant das System das Entladen der Batterie ins Netz zum höchsten Tagespreis und entlädt nur die Energie, die nicht für den Tagesverbrauch des Objekts benötigt wird. Mit den Parametern unten können Sie den Preis für das Entladen der gesamten Batteriekapazität und das Entladen nur des Teils der Batteriekapazität festlegen, der nicht für den Nachtverbrauch benötigt wird.",
  "settings.spot.battery_overflow.subtitle": "Ermöglicht das Entladen der überschüssigen Energie in der Batterie ins Netz in der günstigsten Stunde",
  "settings.spot.battery_overflow_price": "Mindestpreis für das Entladen der Batterie",
  "settings.spot.battery_overflow_price.help": "Wenn der Spotpreis höher als dieser Wert ist, wird die überschüssige Batteriekapazität ins Netz entladen. Das bedeutet, dass die Energie in der Batterie für den Nacht- und Morgenverbrauch gespeichert wird. Die Energie für den Verbrauch des Objekts wird nicht aus dem Netz bezogen.",
  "settings.spot.battery_overflow_price.subtitle": "Die Energie wird in der Batterie für den Nachtverbrauch gespeichert",
  "settings.spot.battery_strategy": "Strategie für das Spot-Laden der Batterie",
  "settings.spot.battery_strategy.help": "Mit diesem Schieberegler können Sie einfach die Präferenz für die Nutzung der Batterie im Spot-Handel festlegen. Niedrigere Werte (ab 20 %) bedeuten weniger Batteriezyklen und damit selteneres Laden/Entladen nach Spotpreisen. Höhere Werte (bis 70 %) bedeuten das Gegenteil.",
  "settings.spot.battery_strategy_service.subtitle": "Mit dieser Option erlauben Sie den Endbenutzern, die Batteriestrategie auf der Registerkarte Spot festzulegen",
  "settings.spot.battery_strategy_user": "Festlegen der Batteriestrategie durch den Benutzer zulassen",
  "settings.spot.battery_strategy_user.subtitle": "Mit dieser Option erlauben Sie den Endbenutzern, die Batteriestrategie auf der Registerkarte Spot festzulegen",
  "settings.spot.install": "Spot-Handel aktiv",
  "settings.spot.latitude": "Breitengrad",
  "settings.spot.latitude.mess": "Breite",
  "settings.spot.longitude": "Längengrad",
  "settings.spot.longitude.mess": "Länge",
  "settings.spot.min_difference_price_charge_from_grid": "Mindestunterschied im Spotpreis für das Laden der Batterie aus dem Netz",
  "settings.spot.min_difference_price_charge_from_grid.help": "Mit diesem Parameter können Sie das Laden der Batterie vom Spot bei einem geringen Unterschied zwischen dem niedrigsten und dem höchsten Preis steuern. Wenn der Parameter 2 CZK beträgt und der Unterschied zwischen dem höchsten Preis (3 CZK) und dem niedrigsten Preis (1 CZK) des Spots geringer ist, wird das Laden der Batterie vom Spot nicht geplant.",
  "settings.spot.min_difference_price_charge_from_grid.subtitle": "Mindestunterschied im Spotpreis während des Tages, damit die Batterie aus dem Netz geladen wird",
  "settings.spot.overflow": "Überschussoptimierung nach Spotpreisen zulassen",
  "settings.spot.overflow.help": "Wenn Sie diese Option wählen, priorisiert das System den Überschuss ins Netz vor dem Laden der Batterie bei höheren und mittleren Spotpreisen. Das geschieht nur in Jahreszeiten, in denen wir einen Energieüberschuss aus PV erwarten, und in der Regel morgens. Die Optimierung findet bei niedrigen Spotpreisen nicht statt, wenn die Priorität das Laden der Batterie aus PV ist.",
  "settings.spot.overflow.subtitle": "Ermöglicht die Priorisierung des Überschusses vor der Speicherung",
  "settings.spot.overflow_offset": "Maximaler Überschuss bei negativem Preis",
  "settings.spot.overflow_offset.help": "Der Wert gibt den Überschuss ins Verteilnetz bei negativem Preis an. Wir empfehlen, diese Funktion im Fall einer Energiegemeinschaft zu nutzen.",
  "settings.spot.overflow_offset.subtitle": "Der Wert kann nicht höher als der maximale Überschuss eingestellt werden",
  "settings.spot.price.period": "Zeitraum",
  "settings.spot.price_above_price": "Eingestellter Spotpreis",
  "settings.spot.price_below": "Eingestellter Spotpreis",
  "settings.spot.price_distribution_hi": "Preis der Netzenergie im Hochtarif",
  "settings.spot.price_distribution_hi.help": "Preis der Netzenergie im Hochtarif pro kWh. Dieser Preis wird zum Spotpreis addiert, wenn der Hochtarif aktiv ist. Die HDO-Zeiten müssen für die korrekte Berechnung des Preises im Hoch- und Niedertarif eingestellt sein. Diesen Betrag finden Sie auf der Stromrechnung.",
  "settings.spot.price_distribution_low": "Preis der Netzenergie im Niedertarif",
  "settings.spot.price_distribution_low.help": "Preis der Netzenergie im Niedertarif pro kWh. Dieser Preis wird zum Spotpreis addiert, wenn der Niedertarif aktiv ist. Die HDO-Zeiten müssen für die korrekte Berechnung des Preises im Hoch- und Niedertarif eingestellt sein. Diesen Betrag finden Sie auf der Stromrechnung.",
  "settings.spot.price_offset": "Preis für das Verbot von Überschüssen",
  "settings.spot.price_offset.help": "Wir empfehlen, mindestens die Provision/Gebühr des Händlers für den Verkauf von Überschüssen ins Netz einzustellen.",
  "settings.spot.price_offset.subtitle": "Mindest-Spotpreis, unter dem Überschüsse verboten sind. Der Wert wird mit dem Tagesmarkt ohne Netzentgelt verglichen.",
  "settings.spot.region": "Region",
  "settings.thermostat.hp-blocked": "Sperrung der Wärmepumpe",
  "settings.thermostat.hysteresis": "Temperaturhysterese",
  "settings.thermostat.install": "Thermostat aktiv",
  "settings.thermostat.name.label": "Name",
  "settings.thermostat.name1": "Name von Thermostat 1",
  "settings.thermostat.name2": "Name von Thermostat 2",
  "settings.thermostat.name3": "Name von Thermostat 3",
  "settings.thermostat.name4": "Name von Thermostat 4",
  "settings.thermostat.nominal": "Nennleistung der Quelle",
  "settings.thermostat.number-of-thermostat": "Anzahl der Thermostate",
  "settings.utility": "Hausparameter",
  "settings.utility.loadpercent": "Aktuelle Belastung des Sicherungsautomaten",
  "settings.utility.numberofphase": "Dreiphasige Installation",
  "settings.utility.settings.ampers": "Größe des Sicherungsautomaten",
  "settings.utility.settings.loadpercent": "Bei Überschreitung wird der Verbrauch begrenzt",
  "settings.utility.settings.loadpercent_max": "Bei Überschreitung wird der Verbrauch begrenzt",
  "settings.wallbox": "Wallbox",
  "settings.wallbox.install": "Wallbox aktiv",
  "settings.wallbox.name": "Name der Wallbox {number}",
  "settings.wallbox.spot": "Wallbox",
  "settings.wallbox.type": "Wallbox-Typ",
  "shellies.energyMeters": "Energiezähler",
  "shellies.energyMeters.add": "Hinzufügen",
  "shellies.energyMeters.empty": "Keine Energiezähler konfiguriert",
  "shellies.energyMeters.list": "Konfiguration der Energiezähler",
  "shellies.energyMeters.name": "Name",
  "shellies.energyMeters.newMeter": "Neuer Zähler",
  "shellies.energyMeters.shellyId": "Shelly ID",
  "shellies.list": "Shellies",
  "shellies.mqtt_broker_running": "MQTT-Broker-Status",
  "shellies.settings": "Einstellungen",
  "shellies.settings.boiler.active": "Boiler über Shellies verbunden",
  "shellies.settings.boiler.id": "ID der Shellies",
  "shellies.settings.boiler.id.label": "ID",
  "shellies.title": "Shellies",
  "spot.chartview": "Preis ohne Netzentgelt anzeigen",
  "spot.draft": "Modi für heute",
  "spot.draft.actualpricehi": "Der aktuelle Preis ist hoch, senken Sie den Verbrauch",
  "spot.draft.actualpricelow": "Der aktuelle Preis ist niedrig, erhöhen Sie den Verbrauch",
  "spot.draft.hesLevel": "Stufe der HES-Steuerung",
  "spot.draft.hiprice": "Grenzen des reduzierten Verbrauchs",
  "spot.draft.info": "Modi und Empfehlungen für heute",
  "spot.draft.lowprice": "Grenze des erhöhten Verbrauchs",
  "spot.draft.todaystatus_HP": "Speicherung der Wärmepumpe",
  "spot.draft.todaystatus_HW": "Speicherung von Warmwasser",
  "spot.draft.todaystatus_bat": "Speicherung der Batterie",
  "spot.draft.todaystatus_em": "Überschuss",
  "spot.explanation": "Erklärung der Modi",
  "spot.explanation.battery_discharge_to_grid": "Entladen der Batterie ins Netz",
  "spot.explanation.battery_discharge_to_home": "Entladen der Batterie",
  "spot.explanation.hw": "Laden der Batterie aus dem Netz",
  "spot.explanation.info": "Detaillierte Erklärung der Modi für heute",
  "spot.flexibility": "Flexibilitätsschätzung für heute",
  "spot.prediction": "Verbrauchsschätzung für heute",
  "spot.prediction.bat": "Verfügbare Batteriespeicherung",
  "spot.prediction.battery": "Verfügbare Batteriespeicherung",
  "spot.prediction.home": "Normaler Verbrauch des Hauses",
  "spot.prediction.hp": "Wärmepumpe",
  "spot.prediction.hw": "Verfügbare Warmwasserspeicherung",
  "spot.prediction.pv": "Photovoltaik-Erzeugung",
  "spot.prediction.sale": "Energie zum Verkauf",
  "spot.prediction.sale.help": "Verbleibender geplanter täglicher Überschuss, der als Überschuss ins Netz vor der Batteriespeicherung priorisiert wird.",
  "spot.price.period.15min": "15 min",
  "spot.price.period.60min": "60 min",
  "spot.region.cz": "CZ",
  "spot.region.nl": "NL",
  "spot.region.sk": "SK",
  "spot.status": "Spot-Handel",
  "spot.summary.battery_charge_from_grid": "Laden aus dem Netz",
  "spot.summary.battery_charge_from_grid.help": "Das Laden der Batterie aus dem Netz nach dem Spotpreis kann in den Einstellungen aktiviert oder deaktiviert werden. Das System plant das Laden der Batterie bei niedrigen Preisen und berücksichtigt den aktuellen Ladezustand der Batterie und ihre Kapazität. Anhand dieser Parameter bestimmt es die Ladedauer, um die Batterie zu den niedrigsten Kosten zu laden.",
  "spot.summary.battery_discharge": "Entladen der Batterie",
  "spot.summary.battery_discharge.help": "Das Entladen der Batterie ins Haus nach dem Spotpreis kann in den Einstellungen aktiviert oder deaktiviert werden. Das Entladen ist in der Regel bei niedrigen Preisen deaktiviert, wenn es besser ist, Energie aus dem Netz zu nutzen und die Batterie für Zeiten mit höherem Preis zu schonen.",
  "spot.summary.battery_discharge_to_grid": "Entladen ins Netz",
  "spot.summary.battery_discharge_to_grid.help": "Das Entladen der Batterie ins Netz kann in den Einstellungen aktiviert oder deaktiviert werden. Das System plant das Entladen der Batterie ins Netz zu den höchsten Tagespreisen und entlädt nur die Energie, die nicht für den normalen Verbrauch des Hauses benötigt wird.",
  "spot.summary.boiler": "Boiler",
  "spot.summary.boiler.help": "Das System plant das Aufheizen des Boilers bei niedrigen Preisen und berücksichtigt die aktuelle Wassertemperatur, die Boilerkapazität und die gewünschte Temperatur. Anhand dieser Parameter bestimmt es die Aufheizdauer, um den Boiler aufzuheizen.",
  "spot.summary.heat_pump": "Wärmepumpe",
  "spot.summary.heat_pump.help": "Die Wärmepumpe kann in drei Modi betrieben werden: erhöhte Leistung, Normalbetrieb und reduzierte Leistung. Erhöhte Leistung wird bei niedrigen Preisen genutzt, Normalbetrieb bei mittleren Preisen und reduzierte Leistung bei hohen Preisen. Die Verzögerung oder Erhöhung des Verbrauchs kann im Menü der Wärmepumpe aktiviert werden.",
  "spot.summary.heat_pump_level.increase": "Erhöhte Leistung",
  "spot.summary.heat_pump_level.normal": "Normalbetrieb",
  "spot.summary.heat_pump_level.reduction": "Reduzierte Leistung",
  "spot.summary.price": "Preis",
  "spot.summary.price_buy": "Preis mit Netzentgelt",
  "spot.summary.price_distribution": "Netzentgelt",
  "spot.summary.price_level": "Preisniveau",
  "spot.summary.price_level.help": "Infigy sortiert die stündlichen Spotpreise vom niedrigsten zum höchsten und teilt sie in drei etwa gleich große Teile. Wenn die Stundenpreise von 3 CZK bis 10 CZK reichen, könnte der niedrige Preisbereich 3–6 CZK, der mittlere 6–7 CZK und der hohe 7–10 CZK betragen. Der Bereich ändert sich täglich, abhängig von der Häufigkeit der Werte in jedem Preisniveau.",
  "spot.summary.price_level.hi": "Hoher Preis",
  "spot.summary.price_level.low": "Niedriger Preis",
  "spot.summary.price_level.mid": "Mittlerer Preis",
  "spot.summary.price_level_15m": "Preisniveau 15m",
  "spot.summary.price_sell": "Preis ohne Netzentgelt",
  "spot.summary.spotOverflow": "Überschuss ins Netz",
  "spot.summary.spotOverflow.allowed": "Erlaubt",
  "spot.summary.spotOverflow.help": "Beim Zulassen des Überschusses ins Netz im Spot-Handel wird der Spotpreis in der jeweiligen Stunde verglichen. Wenn er niedriger ist als der Preis für das Verbot von Überschüssen aus den Einstellungen, deaktiviert das System den Überschuss in dieser Stunde automatisch.",
  "spot.summary.spotOverflow.restricted": "Eingeschränkt",
  "spot.summary.state.active": "Aktiv",
  "spot.summary.state.inactive": "Inaktiv",
  "spot.summary.time": "Zeit",
  "spot.user.parameters": "Parameter des Spot-Handels",
  "spot_wizard.banner.button": "Brauchen Sie Hilfe? Ich kann Ihnen helfen",
  "spot_wizard.banner.subtitle": "Der Assistent hilft Ihnen bei der Einrichtung des Spot-Handels.",
  "spot_wizard.banner.title": "Brauchen Sie Hilfe? Ich kann Ihnen helfen",
  "spot_wizard.battery_discharge.paragraph1": "Diese Einstellung deaktiviert das Entladen der Batterie bei niedrigen Spotpreisen. So behalten Sie die Energie für höhere Preise während des Tages.",
  "spot_wizard.battery_discharge.paragraph2": "Wenn Sie Energie nur am Spot verkaufen, können Sie das Verbot deaktivieren.",
  "spot_wizard.battery_discharge.title": "Entladen der Batterie in den Eigenverbrauch",
  "spot_wizard.battery_purchase.paragraph1": "Diese Einstellung ermöglicht das Laden der Batterie zum niedrigsten Spotpreis, wenn die Erzeugung gering ist.",
  "spot_wizard.battery_purchase.paragraph2": "Achten Sie auf die Strategieeinstellung. Wenn Sie 20 % einstellen, wartet Infigy überwiegend auf die Photovoltaik. Wenn Sie dagegen 70 % einstellen, kauft Infigy überwiegend am Spot. Wir empfehlen, 25 % einzustellen.",
  "spot_wizard.battery_purchase.paragraph3": "Wenn Sie Energie nur am Spot verkaufen, können Sie das Laden deaktivieren.",
  "spot_wizard.battery_purchase.title": "Energiekauf in die Batterie",
  "spot_wizard.boiler.paragraph1": "Diese Einstellung ermöglicht das Aufheizen des Boilers zu den niedrigsten Preisen des Tages auf die eingestellte Temperatur. Infigy hält weiterhin die Grundtemperatur und nutzt die Temperaturerhöhung vom Spot.",
  "spot_wizard.boiler.paragraph2": "Es ist auch möglich, das Aufheizen bei mittleren oder hohen Preisen zu sperren.",
  "spot_wizard.boiler.paragraph3": "Wenn Sie Energie nur am Spot verkaufen, können Sie die Temperatur auf 10°C einstellen und die Aufheizsperre deaktivieren.",
  "spot_wizard.boiler.title": "Aufheizen des Boilers",
  "spot_wizard.dialog.finish": "Fertigstellen",
  "spot_wizard.dialog.next": "Weiter",
  "spot_wizard.dialog.prev": "Zurück",
  "spot_wizard.dialog.step": "Schritt {current} von {total}",
  "spot_wizard.dialog.title": "Assistent zur Einrichtung des Spot-Handels",
  "spot_wizard.distribution_prices.title": "Geben Sie den Preis für das Netzentgelt in den niedrigen und hohen Preisbereichen ein",
  "spot_wizard.done.description": "Sie haben die Einstellungen für den Spot-Handel abgeschlossen. Alle Parameter können im unteren Teil der Spot-Seite bearbeitet werden, wo Sie diesen Assistenten auch erneut aufrufen können.",
  "spot_wizard.done.title": "Fertig",
  "spot_wizard.evening_peak_discharge.paragraph1": "Infigy schätzt automatisch den Energieverbrauch in den Morgenstunden. Der Überschuss kann zum höchsten Preis des Tages verkauft werden.",
  "spot_wizard.evening_peak_discharge.paragraph2": "Wenn Sie Energie nur am Spot kaufen, können Sie das Entladen deaktivieren.",
  "spot_wizard.evening_peak_discharge.title": "Entladen der Batterie in der Abendspitze",
  "spot_wizard.general_settings.title": "Zuerst allgemeine Einstellungen",
  "spot_wizard.hdo_times.title": "Die Einstellung der HDO-Zeiten bestimmt den Zeitraum mit niedrigem Preis",
  "spot_wizard.heat_pump.paragraph1": "Diese Einstellung ermöglicht es, die Leistung der Wärmepumpe bei niedriger Erzeugung zu erhöhen und bei hohen Preisen zu senken.",
  "spot_wizard.heat_pump.paragraph2": "Wenn Sie Energie nur am Spot verkaufen, können Sie die Verzögerung und Erhöhung des Verbrauchs deaktivieren.",
  "spot_wizard.heat_pump.title": "Wärmepumpe",
  "spot_wizard.info.button1": "Warum wird meine Batterie heute nicht vom Spot geladen?",
  "spot_wizard.info.button2": "Warum wird meine Batterie heute nicht in den Spot entladen?",
  "spot_wizard.info.button3": "Ich brauche Hilfe bei der Einrichtung",
  "spot_wizard.info.help1.title": "Warum wird meine Batterie heute nicht vom Spot geladen?",
  "spot_wizard.info.help2.title": "Warum wird meine Batterie heute nicht in den Spot entladen?",
  "spot_wizard.info.title": "Informationen zum Spot-Handel",
  "spot_wizard.overflow_limit.paragraph1": "Wenn Sie den Spot nur zum Energiekauf nutzen, können Sie -10 CZK einstellen. Der Überschuss ist auf die vom Servicetechniker eingestellte Maximalgröße begrenzt.",
  "spot_wizard.overflow_limit.paragraph2": "Wenn Sie den Spot zum Energieverkauf nutzen, ist es vorteilhaft, die Speicherung bei einem Preis zu stoppen, der der Provision Ihres Lieferanten entspricht. Die Provision beträgt üblicherweise 0.30 - 0.70 CZK/kWh.",
  "spot_wizard.overflow_limit.title": "Begrenzung des Überschusses ins Netz",
  "spot_wizard.preferential_sale.paragraph1": "Diese Funktion stellt den Einspeisevorrang während der Morgenspitze ein. Energie wird bevorzugt ins Netz verkauft, statt in Batterie, Boiler und Wärmepumpe gespeichert zu werden. Die Speicherung wird bei niedrigen Preisen oder nach dem Verkauf der geschätzten überschüssigen Energie wieder aktiviert.",
  "spot_wizard.preferential_sale.paragraph2": "Wenn Sie Energie nur am Spot kaufen, können Sie die Funktion deaktivieren.",
  "spot_wizard.preferential_sale.title": "Vorrangiger Energieverkauf",
  "statistics.battery.statistics": "Ladezustand der Batterie",
  "statistics.boiler.statistics": "Elektrische Boilerheizung",
  "statistics.electrical_grid.statistics": "Bezug aus dem Netz",
  "statistics.electrical_grid.statistics_house_consumption": "Gebäudeverbrauch",
  "statistics.electrical_grid.statistics_overflow": "Überschuss ins Netz",
  "statistics.heatpump.statistics": "Verbrauch der Wärmepumpe",
  "statistics.outdoor_temperature.statistics": "Außentemperatur",
  "statistics.photovoltaics.statistics": "Photovoltaik-Erzeugung",
  "statistics.plug.statistics": "Verbrauch der Steckdose",
  "statistics.wind.statistics": "Erzeugung der Windkraftanlage",
  "stats_delete.button": "Löschen",
  "stats_delete.cancel": "Abbrechen",
  "stats_delete.confirm": "Löschen",
  "stats_delete.confirm.title": "Möchten Sie wirklich alle Statistiken löschen?",
  "stats_delete.title": "Alle Statistiken löschen",
  "stats_export.button": "Exportieren",
  "stats_export.from": "Von",
  "stats_export.metric": "Metrik",
  "stats_export.title": "Statistik exportieren",
  "stats_export.to": "Bis",
  "status.heatWater.flexibility": "Flexibilität aktiv, Erwärmung von Warmwasser",
  "status.heatWater.heating": "Erwärmung von Warmwasser",
  "status.heatWater.hwError": "Der Boiler ist vollständig aufgeheizt oder nicht verfügbar",
  "status.heatWater.inverterError": "Vorwärmen ist inaktiv, der Wechselrichter ist nicht verfügbar",
  "status.heatWater.legionella": "Wassersanierung, Legionellen",
  "status.heatWater.notConnected": "Verbindung kann nicht hergestellt werden",
  "status.heatWater.notLicensed": "Die Boilersteuerung ist nicht lizenziert",
  "status.heatWater.off": "Aus",
  "status.heatWater.overload": "Überlastung des Netzes, Erwärmung gestoppt",
  "status.heatWater.pvHeating": "Erwärmung aus Überschuss",
  "status.heatWater.smartMeterError": "Vorwärmen des Boilers ist inaktiv, der Stromzähler ist nicht verfügbar",
  "status.heatWater.spotHeating": "Erwärmung von Warmwasser vom Spot",
  "status.heatWater.stop": "Stopp",
  "status.heatWater.stopHDO": "Erwärmung bei hohem Preis gesperrt",
  "status.heatWater.stopSOC": "Erwärmung gesperrt, niedriger Batteriestand",
  "status.heatWater.stopSell": "Vorwärmen gesperrt, Energieverkauf",
  "status.heatWater.tempError": "Temperatursensor ist nicht verfügbar",
  "status.photovoltaic.dischargeBlockedByComponents": "Entladen der Batterie pausiert wegen des Verbrauchs ausgewählter Technologien",
  "status.photovoltaic.dischargeBlockedByHDO": "Entladen der Batterie pausiert, Hochtarif aktiv (HDO)",
  "status.photovoltaic.discharging": "Entladen der Batterie",
  "status.photovoltaic.distributionLimit": "Verteilnetz begrenzt die Leistung",
  "status.photovoltaic.feedInPriority": "Einspeisevorrang",
  "status.photovoltaic.flexibilityBatteryStop": "Flexibilität aktiv, Laden und Entladen der Batterie gestoppt",
  "status.photovoltaic.flexibilityCharging": "Flexibilität aktiv, Laden der Batterie aus dem Netz",
  "status.photovoltaic.flexibilityDischarging": "Flexibilität aktiv, Entladen der Batterie ins Netz",
  "status.photovoltaic.flexibilityDoNotDischarge": "Flexibilität aktiv, Verbot des Entladens der Batterie",
  "status.photovoltaic.flexibilityFeedInPriority": "Flexibilität aktiv, Vorrang des Überschusses ins Netz",
  "status.photovoltaic.flexibilityOverflowRestricted": "Flexibilität aktiv, Verbot des Überschusses ins Netz",
  "status.photovoltaic.forcedOverflow": "Flexibilität aktiv, erzwungener Überschuss ins Netz",
  "status.photovoltaic.idle": "Ruhemodus",
  "status.photovoltaic.manualCharging": "Manuelles Laden der Batterie",
  "status.photovoltaic.manualDischarging": "Manuelles Entladen der Batterie",
  "status.photovoltaic.noOverflowLimit": "Kein Überschusslimit",
  "status.photovoltaic.noneInverter": "Wechselrichtertyp nicht eingestellt",
  "status.photovoltaic.notConnected": "Verbindung kann nicht hergestellt werden",
  "status.photovoltaic.notLicensed": "PV-Steuerung ist nicht lizenziert",
  "status.photovoltaic.planCharge": "Geplantes Laden der Batterie",
  "status.photovoltaic.planDischarge": "Geplantes Entladen der Batterie",
  "status.photovoltaic.production": "Energieerzeugung",
  "status.photovoltaic.sellBatteryEnergy": "Verkauf von Energie aus der Batterie",
  "status.photovoltaic.spotCharging": "Laden der Batterie vom Spot",
  "status.photovoltaic.spotStopDischarging": "Entladen gestoppt, niedriger Preis am Spot",
  "status.photovoltaic.standby": "Stand-by-Modus",
  "status.photovoltaic.startUp": "Startmodus",
  "status.plug.batteryControl": "Steckdose aktiv nach Batterie",
  "status.plug.manualControl": "Steckdose aktiv im manuellen Modus",
  "status.plug.notActive": "Steckdose inaktiv",
  "status.plug.notConnected": "Verbindung kann nicht hergestellt werden",
  "status.plug.overflowControl": "Steckdose aktiv nach Überschuss",
  "status.plug.spotControl": "Steckdose aktiv nach Spot",
  "status.plug.stop": "Stopp",
  "status.plug.timeControl": "Steckdose aktiv nach Zeit",
  "status.smartMeter.consumption": "Normaler Verbrauch des Hauses",
  "status.smartMeter.maxLoad": "Maximaler Verbrauch des Hauses",
  "status.smartMeter.none": "",
  "status.smartMeter.overflow": "Energieüberschuss ins Netz",
  "status.smartMeter.overflowLimited": "Überschuss aufgrund eines negativen Preises begrenzt",
  "status.smartMeter.shortage": "Ausfall des Verteilnetzes",
  "status.spotBattery.flexibilityPV": "Flexibilität für PV genutzt",
  "status.spotBattery.flexibilitySpot": "Flexibilität für SPOT genutzt",
  "status.spotBattery.noData": "Keine Daten für die Steuerung",
  "status.spotBattery.spotNotLicensed": "Spot ist nicht lizenziert",
  "status.spotBatteryChargeFromGrid.batteryChargingNotActive": "Laden aus dem Netz ist nicht aktiv",
  "status.spotBatteryChargeFromGrid.batteryChargingPlanned": "Das heutige Laden ist aktiv",
  "status.spotBatteryChargeFromGrid.enoughPVEnergy": "Heutiger erwarteter Tagesüberschuss zum Laden der Batterie",
  "status.spotBatteryChargeFromGrid.priceDifferenceTooLow": "Der heutige Mindestpreisunterschied ist nicht erfüllt",
  "status.spotBatteryChargeFromGrid.spotNotActive": "Spot-Handel ist nicht aktiv",
  "status.spotBatteryDischargeToGrid.batteryDischargingNotActive": "Entladen ins Netz ist nicht aktiv",
  "status.spotBatteryDischargeToGrid.batteryDischargingPlanned": "Das heutige Entladen ist aktiv",
  "status.spotBatteryDischargeToGrid.minPriceNotReached": "Der heutige Mindestpreis für den Verkauf wird nicht erreicht",
  "status.spotBatteryDischargeToGrid.notEnoughBatteryEnergy": "Heute wird erwartet, dass die Batterie über Nacht in den Eigenverbrauch entladen wird",
  "status.spotBatteryDischargeToGrid.spotNotActive": "Spot-Handel ist nicht aktiv",
  "status.spotBatteryDischargeToHome.automaticDischargeMode": "Automatisches Entladen der Batterie gemäß Kapazität",
  "status.spotBatteryDischargeToHome.highPriceDischargeMode": "Entladen der Batterie bei hohem Preis",
  "status.spotBatteryDischargeToHome.mediumAndHighPriceDischargeMode": "Entladen der Batterie bei mittlerem und hohem Preis",
  "status.spotBatteryDischargeToHome.notControlled": "Das Entladen der Batterie ist nicht begrenzt",
  "status.spotHeatPump.flexibilityPV": "Flexibilität für PV genutzt",
  "status.spotHeatPump.flexibilitySpot": "Flexibilität für SPOT genutzt",
  "status.spotHeatPump.noData": "Keine Daten für die Steuerung",
  "status.spotHeatPump.spotNotLicensed": "Spot ist nicht lizenziert",
  "status.spotHeatWater.flexibilityPV": "Flexibilität für PV genutzt",
  "status.spotHeatWater.flexibilitySpot": "Flexibilität für SPOT genutzt",
  "status.spotHeatWater.noData": "Keine Daten für die Steuerung",
  "status.spotHeatWater.spotNotLicensed": "Spot ist nicht lizenziert",
  "status.spotSmartMeter.noData": "Keine Daten für die Steuerung",
  "status.spotSmartMeter.overflowDisabled": "Dauerhafte Überschussbegrenzung",
  "status.spotSmartMeter.overflowFlexibilitySell": "Optimierung des Überschusses für den Verkauf",
  "status.spotSmartMeter.overflowLimited": "Überschuss aufgrund negativer Preise begrenzt",
  "status.spotSmartMeter.spotNotLicensed": "Spot ist nicht lizenziert",
  "status.spotSmartMeter.withoutReduction": "Ohne Begrenzung",
  "status.wind.production": "Energieerzeugung",
  "status.wind.stop": "STOP",
  "status.wind.unavailable": "Nicht verfügbar",
  "subscriptions.fetch": "Abonnement aktualisieren",
  "subscriptions.fetch.button": "Abonnement aktualisieren",
  "subscriptions.last_fetch_at": "Letzte Aktualisierung",
  "subscriptions.premium_active": "Premium aktiv",
  "subscriptions.title": "Abonnement",
  "test-product.app": "Anwendung",
  "test-product.settings": "Einstellungen",
  "test-product.settings.distribution": "Vertrieb",
  "test-product.settings.distribution.Dzd": "DZD",
  "test-product.settings.distribution.Infigy": "Infigy",
  "test-product.settings.distribution.solid_sun": "SolidSun",
  "test-product.settings.license": "Lizenz",
  "test-product.settings.license.HW": "HW",
  "test-product.settings.license.Industrial": "Industrial",
  "test-product.settings.license.Play": "PLAY",
  "test-product.settings.license.Smart": "Smart",
  "test-product.settings.license.basic": "Basic",
  "test-product.test": "Gerätetest",
  "test-product.test.DC": "Prüfung des DC-Kreises",
  "test-product.test.DC.subtitle": "Anschließen der Klemmen, Kabelquerschnitte",
  "test-product.test.component": "Komponentenprüfung",
  "test-product.test.component.subtitle": "Sind Sensor, Etiketten, … vorhanden?",
  "test-product.test.electricmeter": "Prüfung des Smartmeters",
  "test-product.test.electricmeter.subtitle": "Prüfung der Installation des Smartmeters für den Wechselrichter",
  "test-product.test.internet-connect": "Internetverbindung",
  "test-product.test.inverter-connect": "Anschließen des Wechselrichters",
  "test-product.test.license": "Lizenz",
  "test-product.test.license-info": "Lizenz",
  "test-product.test.phase_1": "Test Phase 1",
  "test-product.test.phase_2": "Test Phase 2",
  "test-product.test.phase_3": "Test Phase 3",
  "test-product.test.serialNumber": "Seriennummer des Geräts",
  "test-product.test.serialNumber.label": "Seriennummer",
  "test-product.test.serialNumber.subtitle": "Ohne Seriennummer können der Name des Testers und der Test nicht eingegeben werden",
  "test-product.test.serialNumberSwitchboard": "Produktionsnummer des Schaltschranks",
  "test-product.test.serialNumberSwitchboard.label": "Seriennummer",
  "test-product.test.serialNumberSwitchboard.subtitle": "Ausfüllen, wenn sich das Gerät im Originalschrank befindet",
  "test-product.test.start": "Wenn das Gerät angeschlossen ist",
  "test-product.test.start.button": "Test aktivieren",
  "test-product.test.switchboard": "Prüfung der Übereinstimmung des Schaltschranks",
  "test-product.test.switchboard.subtitle": "Prüfung des Anschlusses der Klemmen, der Platzierung der Komponenten und der korrekten Kabelquerschnitte",
  "test-product.test.temp": "Temperatursensor",
  "test-product.test.tester": "Gerät getestet von",
  "test-product.test.tester.subtitle": "Ohne Namen kann der Test nicht aktiviert werden",
  "thermostat.general": "Allgemeine Einstellungen",
  "thermostat.general.cooling": "Kühlung aktiv",
  "thermostat.general.cooling.pvstability": "Mögliche Aktivierung der Quelle",
  "thermostat.general.heating": "Heizung aktiv",
  "thermostat.range": "Thermostat",
  "thermostat.range.flexibility-temperature": "Flexible Temperatur",
  "thermostat.range.flexibility-temperature.subtitle": "Temperatur, um die das Haus vorgeheizt oder vorgekühlt werden kann",
  "thermostat.range.flexibility_status": "Flexibilitätsmodus des Thermostats",
  "thermostat.range.on": "Thermostat aktiv",
  "thermostat.range.on.subtitle": "Grundtemperatur",
  "thermostat.range.pv-flexibility": "Steuerung anhand der Photovoltaik",
  "thermostat.range.set_temperature": "Solltemperatur",
  "thermostat.range.sp-flexibility-down": "Verbrauch gemäß Spot verschieben",
  "thermostat.range.sp-flexibility-up": "Verbrauch gemäß Spot erhöhen",
  "thermostat.range.status": "Flexibilitätsmodus des Thermostats",
  "thermostat.range.temperature": "Solltemperatur",
  "thermostat.statisticsTemp": "Thermostattemperatur",
  "thermostat.status": "Thermostatmodus",
  "wallbox.3a.on": "Modus 3A",
  "wallbox.3a.on_sub": "Das Laden kann 3A aus dem Verteilnetz beziehen",
  "wallbox.6a.on": "Modus 6A",
  "wallbox.6a.on_sub": "Laden nur aus Photovoltaik",
  "wallbox.NO_CHARGE": "Nicht laden",
  "wallbox.NO_CHARGE.on_sub": "Das Laden ist dauerhaft gesperrt, nur der Zeitplan startet es",
  "wallbox.PV": "Laden gemäß Batterie",
  "wallbox.PV.batteryStart": "Einschalten bei Ladezustand",
  "wallbox.PV.batteryStart.subtitle": "Laden starten, wenn die Batterie geladen wird",
  "wallbox.PV.batteryStop": "Ausschalten bei Ladezustand",
  "wallbox.PV.batteryStop.subtitle": "Laden stoppen, wenn die Batterie geladen wird",
  "wallbox.PV.on": "Aktiv",
  "wallbox.PV.on_sub": "Nach Erreichen der Basisenergie erfolgt das Laden nur bei voll geladener Batterie",
  "wallbox.PV2": "Laden gemäß PV",
  "wallbox.PV2.on": "Aktiv",
  "wallbox.PV2.on_sub": "Ladesteuerung gemäß PV-Leistung",
  "wallbox.PV_FAST": "Vorrangiges Laden gemäß Batterie",
  "wallbox.PV_FAST.batteryMinSoc": "Minimale Batteriereserve",
  "wallbox.PV_FAST.batteryMinSoc.subtitle": "Die Batterie wird wegen des Ladens des Fahrzeugs nicht unter diesen Wert entladen. Solange der Wert nicht überschritten wird, wartet das Laden",
  "wallbox.PV_FAST.on_sub": "Das Laden des Fahrzeugs hat volle Priorität. Es wird nur Energie aus der Batterie oder PV genutzt",
  "wallbox.SPOT": "Laden gemäß Spotpreisen",
  "wallbox.SPOT.hi": "Laden bei hohen Preisen verhindern",
  "wallbox.SPOT.mi": "Laden bei mittleren Preisen verhindern",
  "wallbox.SPOT.on": "Aktiv",
  "wallbox.SPOT.on_sub": "Nach Erreichen der Basisenergie wird bei hohen Spotpreisen blockiert",
  "wallbox.active": "{name}",
  "wallbox.active.subtitle": "Aktiv",
  "wallbox.alfen": "Alfen",
  "wallbox.authorization.status": "Autorisierung",
  "wallbox.authorization.status.authorized": "Autorisiert{cardInfo}",
  "wallbox.authorization.status.denied": "Abgelehnt{cardInfo}",
  "wallbox.authorization.status.pending": "Nicht autorisiert",
  "wallbox.authorization.status.unknown": "Unbekannter Status",
  "wallbox.az_router": "AZ Router",
  "wallbox.common": "Allgemeine Informationen",
  "wallbox.common.power": "Aktueller Verbrauch",
  "wallbox.common.power_today": "Heutiger Verbrauch:",
  "wallbox.common.power_total": "Gesamtverbrauch",
  "wallbox.common.power_year": "Jahresverbrauch:",
  "wallbox.control": "Lademodus",
  "wallbox.ecovolter": "EcoVolter",
  "wallbox.evmate": "EVmate",
  "wallbox.fast-charge": "Schnellladen",
  "wallbox.fast-charge.energy": "Energie für Schnellladen",
  "wallbox.fast-charge.energy_actual": "Geladene Energie im aktuellen Zyklus",
  "wallbox.fast-charge.energy_sub": "Energie, die immer so schnell wie möglich geladen wird. Nach Erreichen dieses Werts wird das Laden von einem der Modi gesteuert.",
  "wallbox.goodwe-ev-charger": "Goodwe",
  "wallbox.inactive.subtitle": "Inaktiv",
  "wallbox.mode.pv.batteryStopConflict.description": "Wenn die Batteriesperre während des Wallbox-Betriebs aktiviert ist, kann der Modus „Laden gemäß Batterie“ nicht aktiviert werden. Um den Modus „Laden gemäß Batterie“ zu aktivieren, müssen Sie zuerst die Batteriesperre auf der Seite „Photovoltaik“ deaktivieren.",
  "wallbox.mode.pv.batteryStopConflict.title": "Modus kann nicht aktiviert werden",
  "wallbox.mybox": "MyBox",
  "wallbox.none": "Keine",
  "wallbox.nonemode": "Reguläres Laden",
  "wallbox.nonemode.amper-auto": "Automatische Steuerung des Ladestroms",
  "wallbox.nonemode.amper-auto.subtitle": "Steuert das Laden so, dass Laden und Entladen der Batterie minimiert werden",
  "wallbox.nonemode.ampers": "Maximaler Ladestrom",
  "wallbox.nonemode.hdo": "Laden nur im Niedertarif",
  "wallbox.nonemode.hdo_sub": "Die HDO-Zeiten müssen in den allgemeinen Einstellungen festgelegt werden",
  "wallbox.nonemode.on": "Aktiv",
  "wallbox.nonemode.on_sub": "Das Auto lädt so schnell wie möglich",
  "wallbox.olife": "Olife",
  "wallbox.other": "Sonstige",
  "wallbox.pv.ampers-auto": "Aktuell gewünschter Ladestrom",
  "wallbox.schedules.description": "Planen Sie das Laden des Elektrofahrzeugs nach Bedarf.",
  "wallbox.schedules.title": "Ladeplaner",
  "wallbox.settings": "Einstellungen",
  "wallbox.solax": "Solax – Kommunikation über Wechselrichter",
  "wallbox.solax-ev-charger": "Solax – Kommunikation über Infigy",
  "wallbox.statistics": "Statistik",
  "wallbox.status": "Wallbox-Modus",
  "wallbox.status.car_not_connected": "Auto nicht verbunden",
  "wallbox.status.charging": "Laden",
  "wallbox.status.charging_with_ventilation": "Laden mit Belüftung",
  "wallbox.status.error": "Fehler",
  "wallbox.status.home": "Wallbox-Modus",
  "wallbox.status.normal": "Normal",
  "wallbox.status.not_connected": "Verbindung kann nicht hergestellt werden",
  "wallbox.status.off": "Wallbox aus",
  "wallbox.status.ready": "Bereit zum Laden",
  "wallbox.sub_status.auto": "gemäß Auto-Modus",
  "wallbox.sub_status.basic_energy": "Basisenergie",
  "wallbox.sub_status.battery": "gemäß Batterie",
  "wallbox.sub_status.battery_fast": "vorrangig gemäß Batterie",
  "wallbox.sub_status.battery_waiting": ", Warten auf Batterieladung",
  "wallbox.sub_status.hdo_block": ", HDO-Sperre",
  "wallbox.sub_status.no_charging": ", Laden ist deaktiviert",
  "wallbox.sub_status.none": "",
  "wallbox.sub_status.photovoltaics": "gemäß PV",
  "wallbox.sub_status.schedule": "gemäß Planer",
  "wallbox.sub_status.spot": "gemäß SPOT",
  "wallbox.sub_status.spot_high": ", hoher SPOT-Preis",
  "wallbox.sub_status.spot_mid": ", mittlerer SPOT-Preis",
  "wallbox.victron-ev-charger": "Victron EV Charger",
  "wallbox.wallboxes.title": "Wallboxen",
  "wallbox_rfid.add_button": "RFID-Karte hinzufügen",
  "wallbox_rfid.delete.cancel": "Abbrechen",
  "wallbox_rfid.delete.confirm": "Löschen",
  "wallbox_rfid.delete.confirm.title": "Karte {name} löschen?",
  "wallbox_rfid.dialog.already_exists": "Die Karte {id} ist bereits unter dem Namen {name} gespeichert.",
  "wallbox_rfid.dialog.already_exists_hint": "Bitte legen Sie eine andere Karte auf oder schließen Sie den Dialog.",
  "wallbox_rfid.dialog.cancel": "Abbrechen",
  "wallbox_rfid.dialog.name_label": "Name der Karte",
  "wallbox_rfid.dialog.save": "Speichern",
  "wallbox_rfid.dialog.scanned_id": "Karten-ID: {id}",
  "wallbox_rfid.dialog.title": "RFID-Karte hinzufügen",
  "wallbox_rfid.dialog.waiting": "Bitte legen Sie die Karte an das Lesegerät…",
  "wallbox_rfid.edit.dialog.title": "RFID-Karte bearbeiten",
  "wallbox_wizard.cancel": "Abbrechen",
  "wallbox_wizard.custom_device_ip_address.alert": "Bitte stellen Sie sicher, dass sich die IP-Adresse der Wallbox nicht ändert (z. B. wenn die Wallbox eine DHCP-Adresse verwendet).",
  "wallbox_wizard.custom_device_ip_address.input": "IP-Adresse der Wallbox",
  "wallbox_wizard.multiple_wallboxes.alert": "Für die Konfiguration mehrerer Wallboxen wenden Sie sich bitte an die Support-Hotline. Den Kontakt finden Sie im technischen Wiki von Infigy.",
  "wallbox_wizard.multiple_wallboxes.label": "Mehrere Wallboxen",
  "wallbox_wizard.open": "Wallbox konfigurieren",
  "wallbox_wizard.save": "Speichern",
  "wallbox_wizard.title": "Wallbox-Konfiguration",
  "welcome.subtitle": "Anwendungen für häusliche und moderne Energie an einem Ort!",
  "welcome.title": "Willkommen bei Infigy!",
  "wifi_ap_config.interface_block.confirm.confirmation_text": "{blocked, select, true {Sperren} other {Entsperren}}",
  "wifi_ap_config.interface_block.confirm.content": "Möchten Sie WiFi wirklich {blocked, select, true {sperren} other {entsperren}}?",
  "wifi_ap_config.interface_block.confirm.title": "WiFi-Status ändern",
  "wifi_ap_config.passphrase_change.confirm.passphrase": "Passwort",
  "wifi_ap_config.passphrase_change.confirm.title": "WiFi-Passwort ändern",
  "wifi_ap_config.wifi_interface_blocked.button": "{blocked, select, true {Entsperren} other {Sperren}}",
  "wifi_ap_config.wifi_interface_blocked.title": "WiFi-Status",
  "wifi_ap_config.wifi_interface_blocked.value": "{blocked, select, true {Gesperrt} other {Aktiv}}",
  "wind.common": "Allgemeine Informationen",
  "wind.common.battery_charged_total": "Gesamtleistung in die Batterie",
  "wind.common.battery_current": "Batteriestrom",
  "wind.common.battery_power": "Batterieleistung",
  "wind.common.battery_voltage": "Batteriespannung",
  "wind.common.load_current": "Laststrom",
  "wind.common.power": "Aktuelle Windleistung",
  "wind.common.power_today": "Heutige Erzeugung:",
  "wind.common.power_total": "Gesamterzeugung",
  "wind.common.power_year": "Jahreserzeugung:",
  "wind.common.resistor_power": "Laststrom",
  "wind.statistics": "Statistik",
  "wind.statistics.battery_charge_power": "Batterieleistung",
  "wind.statistics.load_current": "Laststrom",
  "wind.statistics.power": "Leistung der Windkraftanlage",
  "wind.statistics.wind_speed": "Windgeschwindigkeit",
  "wind.status": "Modus der Windkraftanlage"
}
